<template>
	<div id="newQianniu">
		<el-tabs tab-position="left" v-model="tabCurrent" @tab-click="handleClick">
	    <!--第0步 通关必看-->
	    <!-- <el-tab-pane name="zero">
	    	<div slot="label" class="tab-slot">
	    		<p class="title">通关必看</p>
	    		<div class="hover-con">
		    		<p><i class="el-icon-video-play"></i></p>
		    		<p>点击学习</p>
	    		</div>
	    	</div>
	    	<div id="startvideo" class="startvideo">
					<div class="tip">
						<p><i class="el-icon-video-play"></i></p>
						<p>
							<a class="startstudy" @click="startVideo">开始学习</a>
						</p>
					</div>
				</div>
				<div id="video-zero" class="video-box">
					<video id="zero" src="http://taojinyun.file.itaojin.cn/qianniusource/20200302.mp4?version=1221" controls="controls" class="video">
						您的浏览器不支持 video 标签。
					</video>
				</div>
				<div id="stoptip-zero" class="stoptip">
					<div class="tip">
						<span class="el-icon-success"></span>
						<p>视频学习完毕，根据提示实操练习</p>
						<p>
							<a class="restart" @click="restartVideo"><i class="el-icon-refresh-left"></i>重播</a>
							<a class="startstudy" @click="studyNext('#tab-first')">继续下一步学习</a>
						</p>
					</div>
				</div>
	    </el-tab-pane> -->
	    <!--第1步 搜狗输入法快捷键-->
	    <el-tab-pane name="first">
	    	<div slot="label" class="tab-slot">
	    		<p class="title">1、搜狗输入法的截屏功能</p>
	    		<div class="hover-con">
		    		<p><i class="el-icon-video-play"></i></p>
		    		<p>点击学习</p>
	    		</div>
	    	</div>
				<div id="video-first" class="video-box">
					<video id="first" src="http://res.study.itaojin.cn/2023-02/62fe7f6473a2439eb02b097878cc8ca0.mp4" controls="controls" class="video">
						您的浏览器不支持 video 标签。
					</video>
				</div>
				<div id="stoptip-first" class="stoptip">
					<div class="tip">
						<span class="el-icon-success"></span>
						<p>视频学习完毕，根据提示实操练习</p>
						<p>
							<a class="restart" @click="restartVideo"><i class="el-icon-refresh-left"></i>重播</a>
							<a class="startstudy" @click="startStudy">开始实操练习</a>
						</p>
					</div>
				</div>
				<div id="content-first" class="content">
					<div class="con-left">
                        <!-- 输入法切换 -->
						<div v-show="isShowqh1_1" class="qnbox">
							<img class="qnbg" src="../../../static/workoff/excelimg/sougou/qh1-1.png" />
							<img class="qhtb1-1" src="../../../static/workoff/excelimg/sougou/qhtb1-1.png" @mousemove="showLoginqh1_1" />
						</div>
						<div v-show="isShowqh1_2" class="qnbox">
							<img class="qnbg" src="../../../static/workoff/excelimg/sougou/qh1-2.png" />
							<img class="qhtb1-2" src="../../../static/workoff/excelimg/sougou/qhtb1-2.png" @click="showLoginqh1_2" />
						
						</div>
						<div v-show="isShowqh1_3" class="qnbox">
							<img class="qnbg" src="../../../static/workoff/excelimg/sougou/qh1-3.png" />
							<img class="qhtb1-3" src="../../../static/workoff/excelimg/sougou/qhtb1-3.png" @mousemove="showLoginqh1_3" />
						
						</div>
						<div v-show="isShowqh1_4" class="qnbox">
							<img class="qnbg" src="../../../static/workoff/excelimg/sougou/qh1-4.png" />
							<img class="qhtb1-4" src="../../../static/workoff/excelimg/sougou/qhtb1-4.png" @click="showLoginqh1_4" />
						
						</div>
						<div v-show="isShowqh1_5" class="qnbox">
							<img class="qnbg" src="../../../static/workoff/excelimg/sougou/qh1-5.png" />
							<!-- <img class="qhtb1-4" src="../../../static/workoff/excelimg/sougou/qhtb1-4.png" @click="showLoginqh1_4" /> -->
							
						</div>
                        <!-- 设置截屏 -->
                        <div v-show="isShowjp1_1" class="qnbox">
							<img class="qnbg" src="../../../static/workoff/excelimg/sougou/qh1-5.png" />
							<img class="jptb1-1" src="../../../static/workoff/excelimg/sougou/jptb1-1.png" @mousemove="showLoginjp1_1" />
						</div>
                        <div v-show="isShowjp1_2" class="qnbox">
							<img class="qnbg" src="../../../static/workoff/excelimg/sougou/jp1-1.png" />
							<img class="jptb1-2" src="../../../static/workoff/excelimg/sougou/jptb1-2.png" @click="showLoginjp1_2" />
						</div>
                        <div v-show="isShowjp1_3" class="qnbox">
							<img class="qnbg" src="../../../static/workoff/excelimg/sougou/jp1-2.png" />
							<img class="jptb1-3" src="../../../static/workoff/excelimg/sougou/jptb1-3.png" @mousemove="showLoginjp1_3" />
						</div>
                        <div v-show="isShowjp1_4" class="qnbox">
							<img class="qnbg" src="../../../static/workoff/excelimg/sougou/jp1-3.png" />
							<img class="jptb1-3" src="../../../static/workoff/excelimg/sougou/jptb1-3.png" @contextmenu.prevent.stop="showLoginjp1_4($event)" />
						</div>
                        <div v-show="isShowjp1_5" class="qnbox">
							<img class="qnbg" src="../../../static/workoff/excelimg/sougou/jp1-4.png" />
							<img class="jptb1-4" src="../../../static/workoff/excelimg/sougou/jptb1-4.png" @click="showLoginjp1_5" />
						</div>
                        <div v-show="isShowjp1_6" class="qnbox">
							<img class="qnbg" src="../../../static/workoff/excelimg/sougou/jp1-5.png" />
							<!-- <img class="jptb1-4" src="../../../static/workoff/excelimg/sougou/jptb1-4.png" @mousemove="showLoginjp1_5" /> -->
						</div>
                        <!-- 设置截屏快捷键 -->
                        <div v-show="isShowkj1_1" class="qnbox">
							<img class="qnbg" src="../../../static/workoff/excelimg/sougou/kj1-1.png" />
							<img class="kjtb1-1" src="../../../static/workoff/excelimg/sougou/kjtb1-1.png" @mousemove="showLoginkj1_1" />
						</div>
                        <div v-show="isShowkj1_2" class="qnbox">
							<img class="qnbg" src="../../../static/workoff/excelimg/sougou/kj1-2.png" />
							<img class="kjtb1-2" src="../../../static/workoff/excelimg/sougou/kjtb1-1.png" @click="showLoginkj1_2" />
						</div>
                        <div v-show="isShowkj1_3" class="qnbox">
							<img class="qnbg" src="../../../static/workoff/excelimg/sougou/kj1-1.png" />
							<img class="kjtb1-3" src="../../../static/workoff/excelimg/sougou/kj1-3.png" />
							<img class="kjtb1-4" src="../../../static/workoff/excelimg/sougou/kjtb1-2.png" @click="showLoginkj1_3" />
						</div>
                        <div v-show="isShowkj1_4" class="qnbox">
							<img class="qnbg" src="../../../static/workoff/excelimg/sougou/kj1-4.png" />	
							<img class="kjtb1-5" src="../../../static/workoff/excelimg/sougou/kjtb1-3.png" @mousemove="showLoginkj1_4" />
						</div>
                        <div v-show="isShowkj1_5" class="qnbox">
							<img class="qnbg" src="../../../static/workoff/excelimg/sougou/kj1-5.png" />	
							<img class="kjtb1-6" src="../../../static/workoff/excelimg/sougou/kjtb1-4.png" @click="showLoginkj1_5" />
						</div>
                        <div v-show="isShowkj1_6" class="qnbox">
							<img class="qnbg" src="../../../static/workoff/excelimg/sougou/kj1-6.png" />	
							<img class="kjtb1-6" src="../../../static/workoff/excelimg/sougou/kjtb1-4.png" />
							<div class="kjtb1-6-1_box"><img class="kjtb1-6-1" src="../../../static/workoff/excelimg/sougou/kj1-7.png" />
							<img class="kjtb1-8" src="../../../static/workoff/excelimg/sougou/kjtb1-6.png" @mousemove="showLoginkj1_6"/>
							</div>
							
						</div>
                        <!-- <div v-show="isShowkj1_7" class="qnbox">
							<img class="qnbg" src="../../../static/workoff/excelimg/sougou/kj1-6.png"/>
							<img class="kjtb1-7" src="../../../static/workoff/excelimg/sougou/kjtb1-5.png"/>
							<img class="kjtb1-8" src="../../../static/workoff/excelimg/sougou/kjtb1-6.png" @mousemove="showLoginkj1_6"/>
						</div> -->
                        <div v-show="isShowkj1_8" class="qnbox">
							<img class="qnbg" src="../../../static/workoff/excelimg/sougou/kj1-8.png"/>	
							
							<img class="kjtb1-9" src="../../../static/workoff/excelimg/sougou/kjtb1-7.png" @click="showLoginkj1_7"/>
						</div>
						<!-- 快捷键 -->
                        <div v-show="isShowkj1_9" class="qnbox">
							<!-- <img class="qnbg" src="../../../static/workoff/excelimg/sougou/kj1-9.png" @mousewheel.prevent="showLoginkj1_8"/>	 -->
							<img class="qnbg" src="../../../static/workoff/excelimg/sougou/kj1-9.png" />
							<div class="kjtb1-9-1">
								<img class="kjtb1-10" src="../../../static/workoff/excelimg/sougou/kjtb1-8-1.png" />
								<img class="kjtb1-11" src="../../../static/workoff/excelimg/sougou/kjtb1-9.png" @mousemove="showLoginkj1_9"/>	
							</div>	
						</div>
                        <!-- <div v-show="isShowkj1_10" class="qnbox">
							<img class="qnbg" src="../../../static/workoff/excelimg/sougou/kj1-9.png"/>	
							<img class="kjtb1-10" src="../../../static/workoff/excelimg/sougou/kjtb1-8.png" />
							<img class="kjtb1-11" src="../../../static/workoff/excelimg/sougou/kjtb1-9.png" @mousemove="showLoginkj1_9"/>
						</div> -->
                        <div v-show="isShowkj1_11" class="qnbox">
							<img class="qnbg" src="../../../static/workoff/excelimg/sougou/kj1-10.png"/>	
							<img class="kjtb1-12" src="../../../static/workoff/excelimg/sougou/kjtb1-10.png" @click="showLoginkj1_10"/>
							
						</div>
                        <div v-show="isShowkj1_12" class="qnbox">
							<img class="qnbg" src="../../../static/workoff/excelimg/sougou/kj1-11.png"/>	
						
							
						</div>
						
					</div>
					<div class="con-right">
						<h3>
							<span class="line"></span>
							提示
						</h3>
						<!--双击图标-->
						<p v-if="isShowqh1_1 || isShowqh1_2 || isShowqh1_3 || isShowqh1_4 || isShowqh1_5">将<span style="color: red;font-weight:bold;">左侧练习场</span>中，<span style="color: red;font-weight:bold;">右下角</span>的输入法<span style="color: red;font-weight:bold;">切换</span>为<span style="color: red;font-weight:bold;">搜狗输入法</span></p>
						<p v-if="isShowjp1_1 || isShowjp1_2 || isShowjp1_3 || isShowjp1_4 || isShowjp1_5 || isShowjp1_6">打开搜狗输入法的<span style="color: red;font-weight:bold;">智能输入助手,</span>将<span style="color: red;font-weight:bold;">截屏</span>功能快捷方式设置到<span style="color: red;font-weight:bold;">桌面</span>上</p>
						<p v-if="isShowkj1_1 || isShowkj1_2 || isShowkj1_3 || isShowkj1_4 || isShowkj1_5 || isShowkj1_6 || isShowkj1_8 || isShowkj1_9 || isShowkj1_10 || isShowkj1_11|| isShowkj1_12">在搜狗输入法的<span style="color: red;font-weight:bold;">菜单</span>中，将<span style="color: red;font-weight:bold;">截屏</span>的<span style="color: red;font-weight:bold;">快捷键</span>设置为Ctrl+Alt+Q</p>

						<!--登录-->
						<!-- <template v-if="isShowLoginImg">
							<p>首次登录需要找主管获取账号密码。本次模拟练习，请点击下方按钮获取账号密码。</p>
							<el-button type="primary" @click="showPassword = true">获取账号密码</el-button>
							<template v-if="showPassword">
								<p>账号（<span style="color: red;font-weight:bold;">账号中间的冒号是英文冒号</span>）：</p>
								<p><span style="color: red;font-weight:bold;">淘金客服:001</span></p>
								<p>密码：</p>
								<p><span style="color: red;font-weight:bold;">TJ2019</span></p>
							</template>
						</template> -->
						<!--获取随机码-->
						<!-- <template v-if="isShowRnd">
							<p>首次登录需要找主管获取短信验证码。本次模拟练习，请点击下方按钮获取短信验证码。</p>
							<el-button type="primary" @click="showRnd = true">获取短信验证码</el-button>
							<template v-if="showRnd">
								<p>短信验证码：</p>
								<p><span style="color: red;font-weight:bold;">660220</span></p>
							</template>
						</template> -->
						<!--进入接待中心-->	
						<!-- <p v-if="isShowLoginIndex">请进入千牛接待中心</p> -->
					</div>
				</div>
				<div id="studytip-first" class="stoptip">
					<div class="tip">
						<span class="el-icon-success"></span>
						<p>实操通关，进入下一关吧</p>
						<p>
							<a class="restart" @click="restartStudyFirst"><i class="el-icon-refresh-left"></i>重练</a>
							<a class="startstudy" @click="studyNext('#tab-second')">GO，下一关</a>
						</p>
					</div>
				</div>
				<div class="study-box">
					<h3>
						<span class="line"></span>
						查看学习资料
					</h3>
					<el-row>
						<el-col :span="20">
							<img class="img-box" src="../../../static/newqianniu/ppt.png" />
							<div class="con-box">
								<p>搜狗输入法练习-截屏功能.ppt</p>
								<p>
									<a v-if="isOpenPpt" class="btn-open" @click="viewPpt(false)">点击收起</a>
									<a v-else class="btn-open" @click="viewPpt">点击展开</a>
								</p>
							</div>
						</el-col>
						<el-col :span="4">
							<el-button v-if="isShowBtn[tabCurrent]" type="primary" class="pull-right startbtn" @click="startStudy">开始练习</el-button>
						</el-col>
					</el-row>
					<div id="pdf_viewer"></div>
				</div>
	    </el-tab-pane>
	    <!--第2步 搜狗输入法的快捷短语-->
	     
	    <el-tab-pane name="second">
	    	<div slot="label" class="tab-slot">
	    		<p class="title">2、搜狗输入法的快捷短语</p>
	    		<div class="hover-con">
		    		<p><i class="el-icon-video-play"></i></p>
		    		<p>点击学习</p>
	    		</div>
	    	</div>
	    	<div id="video-second" class="video-box">
					<video id="second" src="http://res.study.itaojin.cn/2023-02/82f510f141db4151a86594302eac1b11.mp4" controls="controls" class="video">
						您的浏览器不支持 video 标签。
					</video>
				</div>
				<div id="stoptip-second" class="stoptip">
					<div class="tip">
						<span class="el-icon-success"></span>
						<p>视频学习完毕，根据提示实操练习</p>
						<p>
							<a class="restart" @click="restartVideo"><i class="el-icon-refresh-left"></i>重播</a>
							<a class="startstudy" @click="startStudy">开始实操练习</a>
						</p>
					</div>
				</div>
				<div id="content-second" class="content">
					<div class="con-left">
					<div v-show="isShowdy1_1" class="qnbox">
							<img class="qnbg" src="../../../static/workoff/excelimg/sougou/dy1-1.png" />
							<img class="dytb1-1" src="../../../static/workoff/excelimg/sougou/dytb1-1.png" @mousemove="showLogindy1_1" />
					</div>
					<div v-show="isShowdy1_2" class="qnbox">
							<img class="qnbg" src="../../../static/workoff/excelimg/sougou/dy1-2.png" />
							<img class="dytb1-2" src="../../../static/workoff/excelimg/sougou/dytb1-2.png" @click="showLogindy1_2" />
					</div>
					<div v-show="isShowdy1_3" class="qnbox">
							<!-- <img class="qnbg" src="../../../static/workoff/excelimg/sougou/dy1-3.png" @mousewheel.prevent="showLogindy1_3"/> -->
							<img class="qnbg" src="../../../static/workoff/excelimg/sougou/dy1-3.png"/>
							<div class="qnbg1-3-1box">
								<img class="dytb1-3" src="../../../static/workoff/excelimg/sougou/dytb1-4.png"  />
								<img class="dytb1-4" src="../../../static/workoff/excelimg/sougou/dytb1-5.png" @mousemove='showLogindy1_3' />
							</div>
							<!-- <img class="dytb1-2" src="../../../static/workoff/excelimg/sougou/dytb1-2.png"  /> -->
					</div>
					<div v-show="isShowdy1_4" class="qnbox">
							<img class="qnbg" src="../../../static/workoff/excelimg/sougou/dy1-4.png" />
							<img class="dytb1-5" src="../../../static/workoff/excelimg/sougou/dytb1-6.png"  @click="showLogindy1_4"/>
					</div>
					<div v-show="isShowdy1_5" class="qnbox">
							<img class="qnbg" src="../../../static/workoff/excelimg/sougou/dy1-5.png" />
							<img class="dytb1-6" src="../../../static/workoff/excelimg/sougou/dytb1-7.png"  @mousemove="showLogindy1_5"/>
					</div>
					<div v-show="isShowdy1_6" class="qnbox">
							<img class="qnbg" src="../../../static/workoff/excelimg/sougou/dy1-6.png" />
							<img class="dytb1-7" src="../../../static/workoff/excelimg/sougou/dytb1-8.png"  @click="showLogindy1_6"/>
					</div>
					<div v-show="isShowdy1_7" class="qnbox">
							<img class="qnbg" src="../../../static/workoff/excelimg/sougou/dy1-7.png" />
							<div class="isShowdy1_7_input"><el-input v-model="isShowdy1_7_input"></el-input></div>
							<div class="isShowdy1_7_textarea"><el-input type="textarea" :rows="2"  v-model="isShowdy1_7_textarea" resize="none"></el-input></div>
							<!-- <div class="isShowdy1_7_select"> 
								<el-select v-model="isShowdy1_7_select" >
									<el-option v-for="item in isShowdy1_7_selectopint" :key="item.value" :label="item.label" :value="item.value"></el-option>
								</el-select>
							</div> -->
							<img class="dytb1-8" src="../../../static/workoff/excelimg/sougou/dytb1-9.png"  @click="showLogindy1_7"/>			
					</div>
					<div v-show="isShowdy1_8" class="qnbox">
							<img class="qnbg" src="../../../static/workoff/excelimg/sougou/dy1-9.png" />
							<div class="isShowdy1_7_input"><el-input v-model="isShowdy1_7_input"></el-input></div>
							<div class="isShowdy1_7_textarea"><el-input type="textarea" :rows="2"  v-model="isShowdy1_7_textarea" resize="none"></el-input></div>
							<div class="isShowdy1_7_select"> 
								<el-select v-model="isShowdy1_7_select" >
									<el-option v-for="item in isShowdy1_7_selectopint" :key="item.value" :label="item.label" :value="item.value"></el-option>
								</el-select>
							</div>
							<img class="dytb1-9" src="../../../static/workoff/excelimg/sougou/dytb1-10.png"  @click="showLogindy1_8"/>			
					</div>
					<div v-show="isShowdy1_9" class="qnbox">
							<img class="qnbg" src="../../../static/workoff/excelimg/sougou/dy1-11.png" />
							<!-- <img class="dytb1-7" src="../../../static/workoff/excelimg/sougou/dytb1-8.png"  @click="showLogindy1_6"/> -->
					</div>
					<!-- 调用页面 -->
					<div v-show="isShowdy1_10" class="qnbox">
							<img class="qnbg" src="../../../static/workoff/excelimg/sougou/dy2-1.png" />
							<!-- <img class="dytb1-7" src="../../../static/workoff/excelimg/sougou/dytb1-8.png"  @click="showLogindy1_6"/> -->
					</div>
					<div v-show="isShowdy1_11" class="qnbox">
							<img class="qnbg" src="../../../static/workoff/excelimg/sougou/dy2-2.png" />
							<img class="dytb2-1" src="../../../static/workoff/excelimg/sougou/dytb2-1.png"  @mousemove="showLogindy1_10"/>
					</div>
					<div v-show="isShowdy1_12" class="qnbox">
							<img class="qnbg" src="../../../static/workoff/excelimg/sougou/dy2-3.png" />
							<img class="dytb2-1" src="../../../static/workoff/excelimg/sougou/dytb2-1.png"  @click="showLogindy1_11"/>
					</div>
					<div v-show="isShowdy1_13" class="qnbox">
							<img class="qnbg" src="../../../static/workoff/excelimg/sougou/dy2-4.png" />
							<img class="dytb2-2" src="../../../static/workoff/excelimg/sougou/dytb2-2.png" @click="showLogindy1_12"/>
					</div>
					<div v-show="isShowdy1_14" class="qnbox">
							<img class="qnbg" src="../../../static/workoff/excelimg/sougou/dy2-5.png" />
						
					</div>
					</div>
					<div class="con-right">
						<h3>
							<span class="line"></span>
							提示
						</h3>
						<!-- <p v-if="(isShownr1_1 && isShownr1_3_1==false) || (isShownr1_2 && isShownr1_3_1==false) || (isShownr1_3 && isShownr1_3_1==false)">在<span style="color: red;font-weight:bold;">J2</span>单元格输入<span style="color: red;font-weight:bold;">总分较8月上升（下降），</span>并按<span style="color: red;font-weight:bold;">Enter键</span>确定</p> -->
						<p v-if="isShowdy1_1 || isShowdy1_2 || isShowdy1_3 || isShowdy1_4 || isShowdy1_5 || isShowdy1_6">按照以下要求添加短语:<br>
							缩写：<span style="color: red;font-weight:bold;">bb</span><br>
							内容：<span style="color: red;font-weight:bold;">报备：去上厕所，离开3分钟</span><br>
							点击<span style="color: red;font-weight:bold;">确定并继续添加</span>
						</p>
						<p v-if="isShowdy1_7 ">按照以下要求添加短语：<br>缩写：<span style="color: red;font-weight:bold;">bb</span><br>内容：<span style="color: red;font-weight:bold;">报备：去上厕所，离开3分钟</span><br>点击<span style="color: red;font-weight:bold;">确定并继续添加</span></p>
						<p v-if="isShowdy1_8 || isShowdy1_9">按照以下要求添加短语：<br>缩写：<span style="color: red;font-weight:bold;">bb</span><br>候选位置：<span style="color: red;font-weight:bold;">2</span><br>内容：<span style="color: red;font-weight:bold;">报备：去上厕所，离开5分钟</span><br>点击<span style="color: red;font-weight:bold;">确定</span></p>
						<p v-if="isShowdy1_10 || isShowdy1_11 || isShowdy1_12 || isShowdy1_13 || isShowdy1_14">在聊天输入框中输入<span style="color: red;font-weight:bold;">bb</span>，调出快捷短语，选择离开<span style="color: red;font-weight:bold;">5分钟</span>的短语，并<span style="color: red;font-weight:bold;">发送</span></p>
					
					</div>
				</div>
				<div id="studytip-second" class="stoptip" v-if="OnInline=='false'">
					<div class="tip">
						<span class="el-icon-success"></span>
						 <p>你已完成搜狗输入法的功能学习，<br>接下来请完成《搜狗输入法实操》。</p>
	        <!-- <a class="restart" @click="restartVideoLast"><i class="el-icon-refresh-left"></i>重看视频</a> -->
	        <a class="startstudy" href="/excelstudy" style="width: 160px;">去完成搜狗输入法实操</a>
					</div>
				</div>
				<div class="study-box">
					<h3>
						<span class="line"></span>
						查看学习资料
					</h3>
					<el-row>
						<el-col :span="20">
							<img class="img-box" src="../../../static/newqianniu/ppt.png" />
							<div class="con-box">
								<p>搜狗输入法练习-快捷短语.ppt</p>
								<p>
									<a v-if="isOpenPpt2" class="btn-open" @click="viewPpt2(false)">点击收起</a>
									<a v-else class="btn-open" @click="viewPpt2">点击展开</a>
								</p>
							</div>
						</el-col>
						<el-col :span="4">
							<el-button v-if="isShowBtn[tabCurrent]" type="primary" class="pull-right startbtn" @click="startStudy">开始练习</el-button>
						</el-col>
					</el-row>
					<div id="pdf_viewer2"></div>
				</div>
	    </el-tab-pane>
	
	   
	
	
	   
	     
		    	<!--第7步 下载安装WPS-->
	   
	  </el-tabs>
	 </div>
</template>

<script>
import PDFObject from '../../assets/js/pdfobject.min'
export default {
  data() {
    return {
		data: {
            positionX: 0,
            positionY: 0,
        },
		OnInline:'false',//小助手跳转
    	tabIndex: 1, //序号
    	tabCurrent: 'first', //当前标签页
    	isShowBtn: [], //是否显示开始练习按钮
    	isOpenPpt: false, //是否展开ppt
    	isOpenPpt2: false, //是否展开ppt
    	isOpenPpt3: false, //是否展开ppt
    	isOpenPpt4: false, //是否展开ppt
    	isOpenPpt5: false, //是否展开ppt
      isOpenPpt6: false, //是否展开ppt
      isOpenPpt7: false, //是否展开ppt
      isOpenPpt8: false, //是否展开ppt
      isOpenPpt9: false, //是否展开ppt
      isOpenPpt10: false, //是否展开ppt
      isOpenPpt11: false, //是否展开ppt
      isOpenPpt12: false, //是否展开ppt
    	//第1步
        isShowqh1_1:true,//显示切换输入法页面
        isShowqh1_2:false,//鼠标移入切换输入法
        isShowqh1_3:false,//鼠标点击切换输入法
        isShowqh1_4:false,//鼠标移入搜狗输入法
        isShowqh1_5:false,//鼠标点击搜狗输入法
        // 设置截屏
        isShowjp1_1:false,//延时两秒设置截屏页面显示
        isShowjp1_2:false,//鼠标移入输入法设置
        isShowjp1_3:false,//鼠标点击输入法设置
        isShowjp1_4:false,//鼠标移入截屏设置
        isShowjp1_5:false,//点击鼠标右键
        isShowjp1_6:false,//鼠标点击发送到桌面
        //设置截屏快捷键
        isShowkj1_1:false,//延时两秒显示设置截屏快捷键页面
        isShowkj1_2:false,//鼠标移入输入法图标
        isShowkj1_3:false,//鼠标点击输入法（菜单）图标
        isShowkj1_4:false,//鼠标点击更多设置
        isShowkj1_5:false,//鼠标移入按钮
        isShowkj1_6:false,//鼠标点击按钮,鼠标滚轮滑动
        // isShowkj1_7:false,//监听滚轮滚动
        isShowkj1_8:false,//鼠标移入系统功能快捷键设置
        isShowkj1_9:false,//鼠标点击系统功能快捷键设置
        isShowkj1_10:false,//监听滚轮滚动
        isShowkj1_11:false,//鼠标移入截屏
        isShowkj1_12:false,//鼠标点击截屏

     	//第2步

		// 搜狗输入法的快捷短语
		isShowdy1_1:true,//显示快捷短语的第一张图片
		isShowdy1_2:false,//鼠标移入高级
		isShowdy1_3:false,//鼠标点击高级
		isShowdy1_4:false,//鼠标移入自定义短语
		isShowdy1_5:false,//鼠标点击自定义短语
		isShowdy1_6:false,//鼠标移入添加新短语
		isShowdy1_7:false,//鼠标点击添加新短语
		isShowdy1_7_input:'',//缩写输入框
		isShowdy1_7_textarea:'',//内容输入框
		isShowdy1_7_select:1,//候选位置值
		isShowdy1_7_selectopint:[
			{value:1,
			label:1
			},
			{value:2,
			label:2
			},
			{value:3,
			label:3
			},
			{value:4,
			label:4
			},
			{value:5,
			label:5
			},
			{value:6,
			label:6
			},
			{value:7,
			label:7
			},
			{value:8,
			label:8
			},
			{value:9,
			label:9
			}
		],//候选位置下拉框值
		isShowdy1_8:false,//鼠标点击确定并添加
		isShowdy1_9:false,//鼠标点确定

		// 显示调用界面
		isShowdy1_10:false,//鼠标点击高级
		isb:0,//记录b按下次数
		isShowdy1_11:false,//键盘连续输入bb
		isShowdy1_12:false,//键盘移入2
		isShowdy1_13:false,//键盘点击2
		isShowdy1_14:false,//鼠标点击发送



	
		// 平均
        isShowpj1_1:false,//延时两秒（显示求和页面）
        isShowpj1_2:false,//点击J3
		isShowpj1_3:false,//点击I3
		isShowpj1_4:false,//按下enter
		pj_input1:'293',//I3输入框
		pj1_input:'',//I3输入框
		// 总分
		isShowzf1_1:false,//k3平均页面显示
		isShowzf1_2:false,//点击K3单元格
		isShowzf1_3:false,//点击I3单元格
		isShowzf1_4:false,//点击I3单元格
		isShowzf1_5:false,//按下enter
		
		zf1_input:'',//E3输入框
		
		//修改第一张
		isShowxg1_1:false,//延时两秒（显示新建页面）
		isShowxg1_2:false,//点击下方的Sheet1
		xg_input1:'Sheet1',//Sheet1修改输入框
		isShowxg1_3:false,//按下enter
        //新建
		isShowxj1_1:false,//按下enter延时两秒显示新建页面
		isShowxj1_2:false,//移入+号
		isShowxj1_3:false,//点击+号
		//占比
		isShowzb1_1:false,//占比页面显示
		isShowzb1_2:false,//点击C3
		isShowzb1_3:false,//点击B3
		isShowzb1_4:false,//点击A3
		zb_input1:'',//A3输入框
		isShowzb1_5:false,//按下enter
		//修改第二张
		isShowxg2_1:false,//延时两秒显示第二张修改页面
		isShowxg2_2:false,//点击下面的Sheet2
		xg_input2:'Sheet2',//下面Sheet2输入框
		isShowxg2_3:false,//按下enter
		

        // 第三步
        isShowzt1_1:true,//是否显示第三步第一张图片
		isShowzt1_2:false,//鼠标移入字体样式
		isShowzt1_3:false,//鼠标点击字体样式
		isShowzt1_4:false,//鼠标移入微软雅黑
		isShowzt1_5:false,//鼠标点击微软雅黑
		// 居中
		isShowjz1_1:false,//延时两秒显示居中页面
		isShowjz1_2:false,//鼠标移入居中
		isShowjz1_3:false,//鼠标点击居中
		// 框线
		isShowkx1_1:false,//延迟两秒显示框线页面
		isShowkx1_2:false,//鼠标移入框线
		isShowkx1_3:false,//鼠标点击框线
		isShowkx1_4:false,//鼠标移入所有框线
		isShowkx1_5:false,//鼠标点击所有框线
		// 调A列
		// isShowta1_1:false,//延迟两秒调整A页面显示
		isShowta1_2:false,//移到A列
		isShowta1_3:false,//点击A列
		// 加粗合并第一行
		isShowjchb1_1:false,//延迟两秒显示加粗合并第一行页面
		isShowjchb1_2:false,//鼠标移入大号字体
		isShowjchb1_3:false,//鼠标点击大号字体（第一次）
		isShowjchb1_4:false,//鼠标点击大号字体（第二次）
		isShowjchb1_5:false,//鼠标移入字体加粗
		isShowjchb1_6:false,//鼠标点击字体加粗
		isShowjchb1_7:false,//鼠标移入居中合并
		isShowjchb1_8:false,//鼠标点击居中合并
		isShowjchb1_9:false,//鼠标移入设置颜色
		isShowjchb1_10:false,//鼠标移入颜色
		isShowjchb1_11:false,//鼠标点击颜色
		isShowjchb1_12:false,//
		//颜色换行第二行
		isShowyshh1_1:false,//延时两秒第二行颜色换行页面显示
        isShowyshh1_2:false,//鼠标移入更换字体颜色
        isShowyshh1_3:false,//鼠标点击更换字体颜色
        isShowyshh1_4:false,//鼠标移入自动换行
        isShowyshh1_5:false,//鼠标点击自动换行
		// 冻结
		isShowdj1_1:false,//延时两秒冻结页面显示
		isShowdj1_2:false,//鼠标移入冻结窗格
		isShowdj1_3:false,//鼠标点击冻结窗格
		isShowdj1_4:false,//鼠标移入冻结第二行
		isShowdj1_5:false,//鼠标点击冻结第二行
		// isShownr1_16:false,//插入列后延迟两秒
		// 保留小数
		isShowxs1_1:false,//延迟两秒保留小数页面显示
		isShowxs1_2:false,//鼠标移入常规
		isShowxs1_3:false,//点击常规下标
		isShowxs1_4:false,//鼠标移入其他数字格式
		isShowxs1_5:false,//鼠标点击其他数字格式
		isShowxs1_6:false,//鼠标点击数值
		isShowxs1_7:false,//鼠标移入输入框
		isShowxs1_8:false,//鼠标点击减号输入框
		isShowxs1_9:false,//鼠标移动到确定
		isShowxs1_10:false,//鼠标点击确定
		//占比保留两位小数
		isShowzbbl1_1:false,//延时两秒显示占比保留两位小数页面
		isShowzbbl1_2:false,//鼠标移入常规
		isShowzbbl1_3:false,//点击常规下标
		isShowzbbl1_4:false,//鼠标移动到%
		isShowzbbl1_5:false,//鼠标点击%
		// 第四步
		// 保存文件
        isShowbc1_1:true,//是否显示第四步第一张图片
		bc_input1:'66.67%',//保存第一张图的输入框（用于监听ctrl+s）
		isShowbc1_2:false,//监听ctrl+s
		isShowbc1_3:false,//鼠标移入我的桌面
		isShowbc1_4:false,//鼠标点击我的桌面
		isShowbc1_5:false,//鼠标点击办公软件培训
		isShowbc1_6:false,//鼠标点击文件名
		isShowbc1_7:false,//再点击一次
		isShowbc1_8:false,//显示输入框
		bc_input2:'',
		isShowbc1_9:false,//点击确定
		//另存为
		isShowlc1_1:false,//延时两秒显示另存页面
		isShowlc1_2:false,//点击右键
		isShowlc1_3:false,//鼠标移入另存为
		isShowlc1_4:false,//鼠标点击另存为
		isShowlc1_5:false,//鼠标移入我的桌面
		isShowlc1_6:false,//鼠标点击我的桌面
		isShowlc1_7:false,//鼠标点击保存
		// 第五步
		// 发送文件
		isShowfs1_1:true,//是否显示第五步第一张图片
		isShowfs1_2:false,//鼠标移入关闭
		isShowfs1_3:false,//鼠标点击关闭
		isShowfs1_4:false,//键盘点击表格
		isShowfs1_5:false,//键盘按下ctrl+c
		isShowfs1_6:false,//键盘按下ctrl+v
		isShowfs1_7:false,//点击发送
		// 第六步
		// Word基础功能
		isShowwdzt1_1:true,//是否显示第六步第一张图片
		isShowwdzt1_2:false,//ctrl+A
		isShowwdzt1_3:false,//鼠标移入字体下拉
		isShowwdzt1_4:false,//鼠标点击字体下拉
		isShowwdzt1_5:false,//鼠标移入楷体
		isShowwdzt1_6:false,//鼠标点击楷体
		isShowwdzt1_7:false,//鼠标移入字体大小
		isShowwdzt1_8:false,//鼠标点击字体大小
		isShowwdzt1_9:false,//鼠标移入小四
		isShowwdzt1_10:false,//鼠标点击小四
		// 行距
		isShowwdhj1_1:false,//延迟两秒显示行距页面
		isShowwdhj1_2:false,//鼠标移入行距
		isShowwdhj1_3:false,//鼠标点击行距
		isShowwdhj1_4:false,//鼠标移入1.5
		isShowwdhj1_5:false,//鼠标点击1.5
		// 首行缩进
		isShowwdsj1_1:false,//延时两秒显示首行缩进页面
		isShowwdsj1_1_1:false,//点击鼠标右键
		isShowwdsj1_2:false,//鼠标移入段落
		isShowwdsj1_3:false,//鼠标点击段落
		isShowwdsj1_4:false,//鼠标点击特殊格式
		isShowwdsj1_5:false,//鼠标移动到首行缩进
		isShowwdsj1_6:false,//鼠标点击首行缩进
		isShowwdsj1_7:false,//鼠标点击确定
		//加粗居中
		isShowwdjc1_1:false,//延时两秒显示加粗居中页面
		isShowwdjc1_2:false,//鼠标移到加粗
		isShowwdjc1_3:false,//鼠标点击加粗
		isShowwdjc1_4:false,//鼠标移到居中
		isShowwdjc1_5:false,//鼠标点击居中
		//颜色设置为红色
		isShowwdys1_1:false,//延时两秒显示设置颜色页面
		isShowwdys1_2:false,//鼠标移到颜色
		isShowwdys1_3:false,//鼠标点击颜色
		isShowwdys1_4:false,//鼠标移到红色
		isShowwdys1_5:false,//鼠标点击红色
		// 自然段颜色页面显示(凸显页面)
		isShowwdtx1_1:false,//延迟两秒自然段颜色页面显示(凸显页面)显示
		isShowwdtx1_2:false,//鼠标移到段落颜色
		isShowwdtx1_3:false,//鼠标点击段落颜色
		isShowwdtx1_4:false,//鼠标点击空白







		

		

	}
  },
  mounted() {
		document.getElementById(this.tabCurrent).addEventListener('ended', () => { //该视频播放是否已结束
      $('#startvideo').hide();
      $('#stoptip-'+this.tabCurrent).show();
      this.$set(this.isShowBtn, this.tabCurrent, true)
    }, false);
    document.getElementById(this.tabCurrent).addEventListener('play', () => { //该视频播放是否已结束
      $('#startvideo').hide();
    }, false);

  var _this=this
  document.onkeydown = function (event) {
    let key = window.event.keyCode;
	
	console.log(key,88877)
    if (key === 83 && event.ctrlKey) { 
	    event.returnValue = false // 阻止直接保存网页
		if(_this.isShowbc1_1==true){
			_this.showLoginbc1_1()
		}
		
      // 监听ctrl+S组合键      
       
    } 
    if (key === 67 && event.ctrlKey) { 
	
		if(_this.isShowfs1_4==true){
			_this.Loginfs1_4()
		}
		if(_this.isShownr1_7==true){
			_this.showLoginnr1_7()
		}
	    
	   
      // 监听ctrl+C组合键      
       
    } 
    if (key === 86 && event.ctrlKey) { 
		if(_this.isShowfs1_5==true){
			_this.Loginfs1_5()
		}
		if(_this.isShownr1_9==true){
			_this.listenTwo_3()
		}
	    
	   
      // 监听ctrl+V组合键      
       
    } 
    if (key === 13) { 
		if(_this.isShowqh1_4==true){
			_this.showLoginqh1_4()
		}
		if(_this.isShowpj1_3==true){
			_this.showLoginpj1_1()
		}
		if(_this.isShowzf1_4==true){
			_this.showLoginzf1_1()
		}
		if(_this.isShowzb1_4==true){
			_this.showLoginzb1_1()
		}
		if(_this.isShowfs1_6==true){
			_this.Loginfs1_6()
		}
		if(_this.isShowdy1_13==true){
			_this.showLogindy1_12_1()
		}
	
	    
	   
      // 监听回车     
       
    } 
    if (key === 65 && event.ctrlKey) { 
		if(_this.isShowwdzt1_1==true){
			event.returnValue = false // 阻止
			_this.Loginwdzt1_1()
		}
		
	
	    
	   
      // 监听ctrl+A     
       
    } 
    if (key === 66) { 
		_this.isb++
		console.log(_this.isb,888)
		if(_this.isShowdy1_10==true){
			if(_this.isb==2){
				_this.showLogindy1_9()
			}
		}else{
			_this.isb=0
		}
      // 监听连续按下两次b    
    }else{
		_this.isb=0
	}
	if(key === 50 || key===98){
		if(_this.isShowdy1_11==true){
			_this.showLogindy1_10_1()
		}
	}
   
  }

      // var step = this.$route.query.step;
      // if(step == 12){
      //     this.studyNext('#tab-twelve')
      // }
  },
  watch: {
  	kjdy: function() {
  		if(this.kjdy == '/结束') {
  			this.isShowKjdy06 = true
  		}
  	}
  },
  directives: {
    focus: {
      inserted: function(el, {value}) {
        if(value){
          el.focus();
        }
      }
    }
  },
  created(){
	  if(this.$route.query.OnInline){
		 this.OnInline=this.$route.query.OnInline  
	  }
  },
  methods: {
  	formatDate: function (value) {
	    let date = new Date(value);
	    let y = date.getFullYear();
	    let MM = date.getMonth() + 1;
	    MM = MM < 10 ? ('0' + MM) : MM;
	    let d = date.getDate();
	    d = d < 10 ? ('0' + d) : d;
	    let h = date.getHours();
	    h = h < 10 ? ('0' + h) : h;
	    let m = date.getMinutes();
	    m = m < 10 ? ('0' + m) : m;
	    let s = date.getSeconds();
	    s = s < 10 ? ('0' + s) : s;
	    return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
	  },
	  //第1步-开始播放视频
	  startVideo() {
	  	document.getElementById('zero').play();
	  	$('#startvideo').hide();
	  },
	  //初始化第1步状态值
    initFirst() {
    	  this.isShowqh1_1=true,//显示切换输入法页面
        this.isShowqh1_2=false,//鼠标移入切换输入法
        this.isShowqh1_3=false,//鼠标点击切换输入法
        this.isShowqh1_4=false,//鼠标移入搜狗输入法
        this.isShowqh1_5=false,//鼠标点击搜狗输入法
        // 设置截屏
        this.isShowjp1_1=false,//延时两秒设置截屏页面显示
        this.isShowjp1_2=false,//鼠标移入输入法设置
        this.isShowjp1_3=false,//鼠标点击输入法设置
        this.isShowjp1_4=false,//鼠标移入截屏设置
        this.isShowjp1_5=false,//点击鼠标右键
        this.isShowjp1_6=false,//鼠标点击发送到桌面
        //设置截屏快捷键
        this.isShowkj1_1=false,//延时两秒显示设置截屏快捷键页面
        this.isShowkj1_2=false,//鼠标移入输入法图标
        this.isShowkj1_3=false,//鼠标点击输入法（菜单）图标
        this.isShowkj1_4=false,//鼠标点击更多设置
        this.isShowkj1_5=false,//鼠标移入按钮
        this.isShowkj1_6=false,//鼠标点击按钮,鼠标滚轮滑动
        // isShowkj1_7:false,//监听滚轮滚动
        this.isShowkj1_8=false,//鼠标移入系统功能快捷键设置
        this.isShowkj1_9=false,//鼠标点击系统功能快捷键设置
        this.isShowkj1_10=false,//监听滚轮滚动
        this.isShowkj1_11=false,//鼠标移入截屏
        this.isShowkj1_12=false//鼠标点击截屏

    },
    //初始化第2步状态值
    initSecond() {
    // 搜狗输入法的快捷短语
		this.isShowdy1_1=true,//显示快捷短语的第一张图片
		this.isShowdy1_2=false,//鼠标移入高级
		this.isShowdy1_3=false,//鼠标点击高级
		this.isShowdy1_4=false,//鼠标移入自定义短语
		this.isShowdy1_5=false,//鼠标点击自定义短语
		this.isShowdy1_6=false,//鼠标移入添加新短语
		this.isShowdy1_7=false,//鼠标点击添加新短语
		this.isShowdy1_7_input='',//缩写输入框
		this.isShowdy1_7_textarea='',//内容输入框
		this.isShowdy1_7_select=1,//候选位置值
		this.isShowdy1_7_selectopint=[
			{value:1,
			label:1
			},
			{value:2,
			label:2
			},
			{value:3,
			label:3
			},
			{value:4,
			label:4
			},
			{value:5,
			label:5
			},
			{value:6,
			label:6
			},
			{value:7,
			label:7
			},
			{value:8,
			label:8
			},
			{value:9,
			label:9
			}
		],//候选位置下拉框值
		this.isShowdy1_8=false,//鼠标点击确定并添加
		this.isShowdy1_9=false,//鼠标点确定

		// 显示调用界面
		this.isShowdy1_10=false,//鼠标点击高级
		this.isb=0,//记录b按下次数
		this.isShowdy1_11=false,//键盘连续输入bb
		this.isShowdy1_12=false,//键盘移入2
		this.isShowdy1_13=false,//键盘点击2
		this.isShowdy1_14=false//鼠标点击发送
    },
    //初始化第3步状态值
    initThird() {
    	this.isShowzt1_1=true,//是否显示第三步第一张图片
		this.isShowzt1_2=false,//鼠标移入字体样式
		this.isShowzt1_3=false,//鼠标点击字体样式
		this.isShowzt1_4=false,//鼠标移入微软雅黑
		this.isShowzt1_5=false,//鼠标点击微软雅黑
		// 居中
		this.isShowjz1_1=false,//延时两秒显示居中页面
		this.isShowjz1_2=false,//鼠标移入居中
		this.isShowjz1_3=false,//鼠标点击居中
		// 框线
		this.isShowkx1_1=false,//延迟两秒显示框线页面
		this.isShowkx1_2=false,//鼠标移入框线
		this.isShowkx1_3=false,//鼠标点击框线
		this.isShowkx1_4=false,//鼠标移入所有框线
		this.isShowkx1_5=false,//鼠标点击所有框线
		// 调A列
		// this.isShowta1_1=false,//延迟两秒调整A页面显示
		this.isShowta1_2=false,//移到A列
		this.isShowta1_3=false,//点击A列
		// 加粗合并第一行
		this.isShowjchb1_1=false,//延迟两秒显示加粗合并第一行页面
		this.isShowjchb1_2=false,//鼠标移入大号字体
		this.isShowjchb1_3=false,//鼠标点击大号字体（第一次）
		this.isShowjchb1_4=false,//鼠标点击大号字体（第二次）
		this.isShowjchb1_5=false,//鼠标移入字体加粗
		this.isShowjchb1_6=false,//鼠标点击字体加粗
		this.isShowjchb1_7=false,//鼠标移入居中合并
		this.isShowjchb1_8=false,//鼠标点击居中合并
		this.isShowjchb1_9=false,//鼠标移入设置颜色
		this.isShowjchb1_10=false,//鼠标移入颜色
		this.isShowjchb1_11=false,//鼠标点击颜色
		this.isShowjchb1_12=false,//
		//颜色换行第二行
		this.isShowyshh1_1=false,//延时两秒第二行颜色换行页面显示
        this.isShowyshh1_2=false,//鼠标移入更换字体颜色
        this.isShowyshh1_3=false,//鼠标点击更换字体颜色
        this.isShowyshh1_4=false,//鼠标移入自动换行
        this.isShowyshh1_5=false,//鼠标点击自动换行
		// 冻结
		this.isShowdj1_1=false,//延时两秒冻结页面显示
		this.isShowdj1_2=false,//鼠标移入冻结窗格
		this.isShowdj1_3=false,//鼠标点击冻结窗格
		this.isShowdj1_4=false,//鼠标移入冻结第二行
		this.isShowdj1_5=false,//鼠标点击冻结第二行
		// isShownr1_16:false,//插入列后延迟两秒
		// 保留小数
		this.isShowxs1_1=false,//延迟两秒保留小数页面显示
		this.isShowxs1_2=false,//鼠标移入常规
		this.isShowxs1_3=false,//点击常规下标
		this.isShowxs1_4=false,//鼠标移入其他数字格式
		this.isShowxs1_5=false,//鼠标点击其他数字格式
		this.isShowxs1_6=false,//鼠标点击数值
		this.isShowxs1_7=false,//鼠标移入输入框
		this.isShowxs1_8=false,//鼠标点击减号输入框
		this.isShowxs1_9=false,//鼠标移动到确定
		this.isShowxs1_10=false,//鼠标点击确定
		//占比保留两位小数
		this.isShowzbbl1_1=false,//延时两秒显示占比保留两位小数页面
		this.isShowzbbl1_2=false,//鼠标移入常规
		this.isShowzbbl1_3=false,//点击常规下标
		this.isShowzbbl1_4=false,//鼠标移动到%
		this.isShowzbbl1_5=false//鼠标点击%
    },
    //初始化第4步状态值
    initFour() {
     	this.isShowbc1_1=true,//是否显示第四步第一张图片
		this.bc_input1='66.67%',//保存第一张图的输入框（用于监听ctrl+s）
		this.isShowbc1_2=false,//监听ctrl+s
		this.isShowbc1_3=false,//鼠标移入我的桌面
		this.isShowbc1_4=false,//鼠标点击我的桌面
		this.isShowbc1_5=false,//鼠标点击办公软件培训
		this.isShowbc1_6=false,//鼠标点击文件名
		this.isShowbc1_7=false,//再点击一次
		this.isShowbc1_8=false,//显示输入框
		this.bc_input2='',
		this.isShowbc1_9=false,//点击确定
		//另存为
		this.isShowlc1_1=false,//延时两秒显示另存页面
		this.isShowlc1_2=false,//点击右键
		this.isShowlc1_3=false,//鼠标移入另存为
		this.isShowlc1_4=false,//鼠标点击另存为
		this.isShowlc1_5=false,//鼠标移入我的桌面
		this.isShowlc1_6=false,//鼠标点击我的桌面
		this.isShowlc1_7=false//鼠标点击保存
    },
    //初始化第5步状态值
    initFive() {
    	this.isShowfs1_1=true,//是否显示第五步第一张图片
		this.isShowfs1_2=false,//鼠标移入关闭
		this.isShowfs1_3=false,//鼠标点击关闭
		this.isShowfs1_4=false,//鼠标点击表格
		this.isShowfs1_5=false,//键盘按下ctrl+c
		this.isShowfs1_6=false//键盘按下ctrl+v

    },
    //初始化第6步状态值
    initSix() {
    // Word基础功能
		this.isShowwdzt1_1=true,//是否显示第六步第一张图片
		this.isShowwdzt1_2=false,//ctrl+A
		this.isShowwdzt1_3=false,//鼠标移入字体下拉
		this.isShowwdzt1_4=false,//鼠标点击字体下拉
		this.isShowwdzt1_5=false,//鼠标移入楷体
		this.isShowwdzt1_6=false,//鼠标点击楷体
		this.isShowwdzt1_7=false,//鼠标移入字体大小
		this.isShowwdzt1_8=false,//鼠标点击字体大小
		this.isShowwdzt1_9=false,//鼠标移入小四
		this.isShowwdzt1_10=false,//鼠标点击小四
		// 行距
		this.isShowwdhj1_1=false,//延迟两秒显示行距页面
		this.isShowwdhj1_2=false,//鼠标移入行距
		this.isShowwdhj1_3=false,//鼠标点击行距
		this.isShowwdhj1_4=false,//鼠标移入1.5
		this.isShowwdhj1_5=false,//鼠标点击1.5
		// 首行缩进
		this.isShowwdsj1_1=false,//延时两秒显示首行缩进页面
		this.isShowwdsj1_1_1=false,//点击鼠标右键
		this.isShowwdsj1_2==false,//鼠标移入段落
		this.isShowwdsj1_3=false,//鼠标点击段落
		this.isShowwdsj1_4=false,//鼠标点击特殊格式
		this.isShowwdsj1_5=false,//鼠标移动到首行缩进
		this.isShowwdsj1_6=false,//鼠标点击首行缩进
		this.isShowwdsj1_7=false,//鼠标点击确定
		//加粗居中
		this.isShowwdjc1_1=false,//延时两秒显示加粗居中页面
		this.isShowwdjc1_2=false,//鼠标移到加粗
		this.isShowwdjc1_3=false,//鼠标点击加粗
		this.isShowwdjc1_4=false,//鼠标移到居中
		this.isShowwdjc1_5=false,//鼠标点击居中
		//颜色设置为红色
		this.isShowwdys1_1=false,//延时两秒显示设置颜色页面
		this.isShowwdys1_2=false,//鼠标移到颜色
		this.isShowwdys1_3=false,//鼠标点击颜色
		this.isShowwdys1_4=false,//鼠标移到红色
		this.isShowwdys1_5=false,//鼠标点击红色
		// 自然段颜色页面显示(凸显页面)
		this.isShowwdtx1_1=false,//延迟两秒自然段颜色页面显示(凸显页面)显示
		this.isShowwdtx1_2=false,//鼠标移到段落颜色
		this.isShowwdtx1_3=false,//鼠标点击段落颜色
		this.isShowwdtx1_4=false//鼠标点击空白
    },
    //初始化第7步状态值
    initSeven() {
     	this.isShowZtsbicon = true
     	this.isShowZtsb01 = false
     	this.isShowZtsb02 = false
     	this.isShowZtsb03 = false
     	this.isShowZtsb04 = false
     	this.isShowZtsb05 = false
      this.isShowZtsb06 = false
      this.isShowZtsbTip01 = true;
      this.isShowZtsbTip02 = false;
      this.isShowZtsbTip03 = false;
    },
    //初始化第8步状态值
    initEight() {
     	this.isShowZjgnicon = true
     	this.isShowZjgn01 = false
     	this.isShowZjgn02 = false
     	this.isShowZjgn03 = false
     	this.isShowZjgn04 = false
     	this.isShowZjgn05 = false
    },
    //初始化第9步状态值
    initNine() {
     	this.isShowTjgnicon = true
     	this.isShowTjgn01 = false
     	this.isShowTjgn02 = false
     	this.isShowTjgn03 = false
     	this.isShowTjgn04 = false
     	this.isShowTjgn05 = false
     	this.isShowTjgn06 = false
    },
    //初始化第10步状态值
    initTen() {
     	this.isShowDdcjicon = false
     	this.isShowDdcj01 = false
     	this.isShowDdcj02 = false
     	this.isShowDdcj03 = false
     	this.isShowDdcj04 = false
     	this.isShowDdcj05 = false
     	this.isShowDdcj06 = false
     	this.isShowDdcj07 = true
     	this.isShowDdcj08 = false
     	this.isShowDdcj09 = false
     	this.isShowDdcj10 = false
      this.isShowDdcjTip01 = true 
      this.isShowDdcjTip02 = false 
      this.isShowDdcjTip03 = false 
      this.ddcjbz = ''
      this.ddcjdz = ''
      this.ddcjyf = ''
    },
    //初始化第11步状态值
    initEleven() {
     	this.isShowXjrwicon = true
     	this.isShowXjrw01 = false
     	this.isShowXjrw02 = false
     	this.isShowXjrw03 = false
     	this.isShowXjrw04 = false
     	this.isShowXjrw05 = false
     	this.isShowXjrw06 = false
      this.xjrwmt = this.getLastDaysFromToday(-1) + ' 09:00'
      this.xjrwsj = ''
      this.xjrwtxt = ''
    },
    //初始化第12步状态值
    initTwelve() {
     	this.isShowTcqnicon = true
     	this.isShowTcqn01 = false
     	this.isShowTcqn02 = false
     	this.isShowTcqn03 = false
     	this.isShowTcqn04 = false
     	this.isShowTcqn05 = false
     	this.isShowTcqn06 = false
     	this.isShowTcqn07 = false
     	this.isShowTcqn08 = false
     	this.isShowTcqn09 = false
     	this.isShowTcqn10 = false
     	this.isShowTcqnTip01 = true
     	this.isShowTcqnTip02 = false
    },
  	//初始化所有tab内容
  	initAll() {
  		$('#startvideo').hide();
  		this.isShowBtn = []
    	this.isOpenPpt = false
    	this.isOpenPpt2 = false
    	this.isOpenPpt3 = false
    	this.isOpenPpt4 = false
    	this.isOpenPpt5 = false
      this.isOpenPpt6 = false
      this.isOpenPpt7 = false
      this.isOpenPpt8 = false
      this.isOpenPpt9 = false
      this.isOpenPpt10 = false
      this.isOpenPpt11 = false
      this.isOpenPpt12 = false
      $('#pdf_viewer').height('0');
      $('#pdf_viewer1').height('0');
      $('#pdf_viewer2').height('0');
      $('#pdf_viewer3').height('0');
      $('#pdf_viewer4').height('0');
      $('#pdf_viewer5').height('0');
      $('#pdf_viewer6').height('0');
      $('#pdf_viewer7').height('0');
      $('#pdf_viewer8').height('0');
      $('#pdf_viewer9').height('0');
      $('#pdf_viewer10').height('0');
      $('#pdf_viewer11').height('0');
      $('#pdf_viewer12').height('0');
    	//第1步
    	this.initFirst()
     	//第2步
     	this.initSecond()
     	//第3步
     	this.initThird()
     	//第4步
     	this.initFour()
     	//第5步
     	this.initFive()
     	//第6步
      this.initSix()
      //第7步
      this.initSeven()
      //第8步
      this.initEight()
      //第9步
      this.initNine()
      //第10步
      this.initTen()
      //第11步
      this.initEleven()
      //第12步
      this.initTwelve()
     	$('.content').each(function(i) {
  			$(this).hide();
  		});
  		$('.stoptip').each(function(i) {
  			$(this).hide();
  		});
  		$('.video-box').not('#video-'+this.tabCurrent).each(function(i) {
  			$(this).hide();
  		});
  		$('#video-'+this.tabCurrent).show();
  	},
  	//tab切换
  	handleClick(tab, event) {
		  console.log(tab,111111)
  		this.tabIndex = parseInt(tab.index)+1
  		//内容初始化
  		this.initAll();
  		document.getElementById(this.tabCurrent).play();
  		$('video').not('#'+this.tabCurrent).each(function(i) {
  			var tabId = $(this).attr('id');
  			document.getElementById(tabId).pause();
  			document.getElementById(tabId).currentTime = 0;
  		});
      document.getElementById(this.tabCurrent).addEventListener('ended', () => { //该视频播放是否已结束
	      $('#stoptip-'+this.tabCurrent).show();
        this.$set(this.isShowBtn, this.tabCurrent, true);
      }, false);
    },
  	//展开/收起ppt
    viewPpt(bol) {
    	if(this.isOpenPpt == true || !bol) {
    		this.isOpenPpt = false
    		$('#pdf_viewer').height('0');
    	}else {
    		this.isOpenPpt = true
    		var options = {
          pdfOpenParams: {
            navpanes: 0,
            toolbar: 0,
            statusbar: 0,
            view: "FitV",
            pagemode: "thumbs",
            page: 1
          },
          forcePDFJS: true,
          PDFJS_URL: "http://cmain.static.itaojin.cn/static/main/scripts/vendor/PDFjs/generic/web/viewer.html"
        };
        if(PDFObject.supportsPDFs) {
        	$('#pdf_viewer').height('700px');
          PDFObject.embed('http://res.study.itaojin.cn/2023-02/53a1088d94174ab3b03cd609e3fd39f2.pdf', "#pdf_viewer", options )
        }
    	}
    },
    //展开/收起ppt
    viewPpt2(bol) {
    	if(this.isOpenPpt2 == true || !bol) {
    		this.isOpenPpt2 = false
    		$('#pdf_viewer2').height('0');
    	}else {
    		this.isOpenPpt2 = true
    		var options = {
          pdfOpenParams: {
            navpanes: 0,
            toolbar: 0,
            statusbar: 0,
            view: "FitV",
            pagemode: "thumbs",
            page: 1
          },
          forcePDFJS: true,
          PDFJS_URL: "http://cmain.static.itaojin.cn/static/main/scripts/vendor/PDFjs/generic/web/viewer.html"
        };
        if(PDFObject.supportsPDFs) {
        	$('#pdf_viewer2').height('700px');
          PDFObject.embed('http://res.study.itaojin.cn/2023-02/4c9cc43c2d234113a68c3b9f329c8ce9.pdf', "#pdf_viewer2", options )
        }
    	}
    },
    //展开/收起ppt
    viewPpt3(bol) {
    	if(this.isOpenPpt3 == true || !bol) {
    		this.isOpenPpt3 = false
    		$('#pdf_viewer3').height('0');
    	}else {
    		this.isOpenPpt3 = true
    		var options = {
          pdfOpenParams: {
            navpanes: 0,
            toolbar: 0,
            statusbar: 0,
            view: "FitV",
            pagemode: "thumbs",
            page: 1
          },
          forcePDFJS: true,
          PDFJS_URL: "//cmain.static.itaojin.cn/static/main/scripts/vendor/PDFjs/generic/web/viewer.html"
        };
        if(PDFObject.supportsPDFs) {
        	$('#pdf_viewer3').height('700px');
          PDFObject.embed('//taojinyun.file.itaojin.cn/qianniusource/step3.pdf?version=1221', "#pdf_viewer3", options )
        }
    	}
    },
    //展开/收起ppt
    viewPpt4(bol) {
    	if(this.isOpenPpt4 == true || !bol) {
    		this.isOpenPpt4 = false
    		$('#pdf_viewer4').height('0');
    	}else {
    		this.isOpenPpt4 = true
    		var options = {
          pdfOpenParams: {
            navpanes: 0,
            toolbar: 0,
            statusbar: 0,
            view: "FitV",
            pagemode: "thumbs",
            page: 1
          },
          forcePDFJS: true,
          PDFJS_URL: "//cmain.static.itaojin.cn/static/main/scripts/vendor/PDFjs/generic/web/viewer.html"
        };
        if(PDFObject.supportsPDFs) {
        	$('#pdf_viewer4').height('700px');
          PDFObject.embed('//taojinyun.file.itaojin.cn/qianniusource/step4.pdf?version=1221', "#pdf_viewer4", options )
        }
    	}
    },
    //展开/收起ppt
    viewPpt5(bol) {
    	if(this.isOpenPpt5 == true || !bol) {
    		this.isOpenPpt5 = false
    		$('#pdf_viewer5').height('0');
    	}else {
    		this.isOpenPpt5 = true
    		var options = {
          pdfOpenParams: {
            navpanes: 0,
            toolbar: 0,
            statusbar: 0,
            view: "FitV",
            pagemode: "thumbs",
            page: 1
          },
          forcePDFJS: true,
          PDFJS_URL: "//cmain.static.itaojin.cn/static/main/scripts/vendor/PDFjs/generic/web/viewer.html"
        };
        if(PDFObject.supportsPDFs) {
        	$('#pdf_viewer5').height('700px');
          PDFObject.embed('//taojinyun.file.itaojin.cn/qianniusource/step5.pdf?version=1221', "#pdf_viewer5", options )
        }
    	}
    },
    //展开/收起ppt
    viewPpt6(bol) {
    	if(this.isOpenPpt6 == true || !bol) {
    		this.isOpenPpt6 = false
    		$('#pdf_viewer6').height('0');
    	}else {
    		this.isOpenPpt6 = true
    		var options = {
          pdfOpenParams: {
            navpanes: 0,
            toolbar: 0,
            statusbar: 0,
            view: "FitV",
            pagemode: "thumbs",
            page: 1
          },
          forcePDFJS: true,
          PDFJS_URL: "//cmain.static.itaojin.cn/static/main/scripts/vendor/PDFjs/generic/web/viewer.html"
        };
        if(PDFObject.supportsPDFs) {
        	$('#pdf_viewer6').height('700px');
          PDFObject.embed('//taojinyun.file.itaojin.cn/qianniusource/step6.pdf?version=1221', "#pdf_viewer6", options )
        }
    	}
    },
    //展开/收起ppt
    viewPpt7(bol) {
    	if(this.isOpenPpt7 == true || !bol) {
    		this.isOpenPpt7 = false
    		$('#pdf_viewer7').height('0');
    	}else {
    		this.isOpenPpt7 = true
    		var options = {
          pdfOpenParams: {
            navpanes: 0,
            toolbar: 0,
            statusbar: 0,
            view: "FitV",
            pagemode: "thumbs",
            page: 1
          },
          forcePDFJS: true,
          PDFJS_URL: "//cmain.static.itaojin.cn/static/main/scripts/vendor/PDFjs/generic/web/viewer.html"
        };
        if(PDFObject.supportsPDFs) {
        	$('#pdf_viewer7').height('700px');
          PDFObject.embed('//taojinyun.file.itaojin.cn/qianniusource/step7.pdf?version=1221', "#pdf_viewer7", options )
        }
    	}
    },
    //展开/收起ppt
    viewPpt8(bol) {
    	if(this.isOpenPpt8 == true || !bol) {
    		this.isOpenPpt8 = false
    		$('#pdf_viewer8').height('0');
    	}else {
    		this.isOpenPpt8 = true
    		var options = {
          pdfOpenParams: {
            navpanes: 0,
            toolbar: 0,
            statusbar: 0,
            view: "FitV",
            pagemode: "thumbs",
            page: 1
          },
          forcePDFJS: true,
          PDFJS_URL: "//cmain.static.itaojin.cn/static/main/scripts/vendor/PDFjs/generic/web/viewer.html"
        };
        if(PDFObject.supportsPDFs) {
          $('#pdf_viewer8').height('700px');
        	PDFObject.embed('//taojinyun.file.itaojin.cn/qianniusource/step8.pdf?version=1221', "#pdf_viewer8", options )
        }
    	}
    },
    //展开/收起ppt
    viewPpt9(bol) {
    	if(this.isOpenPpt9 == true || !bol) {
    		this.isOpenPpt9 = false
    		$('#pdf_viewer9').height('0');
    	}else {
    		this.isOpenPpt9 = true
    		var options = {
          pdfOpenParams: {
            navpanes: 0,
            toolbar: 0,
            statusbar: 0,
            view: "FitV",
            pagemode: "thumbs",
            page: 1
          },
          forcePDFJS: true,
          PDFJS_URL: "//cmain.static.itaojin.cn/static/main/scripts/vendor/PDFjs/generic/web/viewer.html"
        };
        if(PDFObject.supportsPDFs) {
          $('#pdf_viewer9').height('700px');
        	PDFObject.embed('//taojinyun.file.itaojin.cn/qianniusource/step9.pdf?version=1221', "#pdf_viewer9", options )
        }
    	}
    },
    //展开/收起ppt
    viewPpt10(bol) {
    	if(this.isOpenPpt10 == true || !bol) {
    		this.isOpenPpt10 = false
    		$('#pdf_viewer10').height('0');
    	}else {
    		this.isOpenPpt10 = true
    		var options = {
          pdfOpenParams: {
            navpanes: 0,
            toolbar: 0,
            statusbar: 0,
            view: "FitV",
            pagemode: "thumbs",
            page: 1
          },
          forcePDFJS: true,
          PDFJS_URL: "//cmain.static.itaojin.cn/static/main/scripts/vendor/PDFjs/generic/web/viewer.html"
        };
        if(PDFObject.supportsPDFs) {
          $('#pdf_viewer10').height('700px');
        	PDFObject.embed('//taojinyun.file.itaojin.cn/qianniusource/step10.pdf?version=1221', "#pdf_viewer10", options )
        }
    	}
    },
    //展开/收起ppt
    viewPpt11(bol) {
    	if(this.isOpenPpt11 == true || !bol) {
    		this.isOpenPpt11 = false
    		$('#pdf_viewer11').height('0');
    	}else {
    		this.isOpenPpt11 = true
    		var options = {
          pdfOpenParams: {
            navpanes: 0,
            toolbar: 0,
            statusbar: 0,
            view: "FitV",
            pagemode: "thumbs",
            page: 1
          },
          forcePDFJS: true,
          PDFJS_URL: "//cmain.static.itaojin.cn/static/main/scripts/vendor/PDFjs/generic/web/viewer.html"
        };
        if(PDFObject.supportsPDFs) {
          $('#pdf_viewer11').height('700px');
        	PDFObject.embed('//taojinyun.file.itaojin.cn/qianniusource/step11.pdf?version=1221', "#pdf_viewer11", options )
        }
    	}
    },
    //展开/收起ppt
    viewPpt12(bol) {
    	if(this.isOpenPpt12 == true || !bol) {
    		this.isOpenPpt12 = false
    		$('#pdf_viewer12').height('0');
    	}else {
    		this.isOpenPpt12 = true
    		var options = {
          pdfOpenParams: {
            navpanes: 0,
            toolbar: 0,
            statusbar: 0,
            view: "FitV",
            pagemode: "thumbs",
            page: 1
          },
          forcePDFJS: true,
          PDFJS_URL: "//cmain.static.itaojin.cn/static/main/scripts/vendor/PDFjs/generic/web/viewer.html"
        };
        if(PDFObject.supportsPDFs) {
          $('#pdf_viewer12').height('700px');
        	PDFObject.embed('//taojinyun.file.itaojin.cn/qianniusource/step12.pdf?version=1221', "#pdf_viewer12", options )
        }
    	}
    },
    //重播
    restartVideo() {
    	document.getElementById(this.tabCurrent).play();
    	$('#stoptip-'+this.tabCurrent).hide();
    },
    //最后一节-重看视频
    restartVideoLast() {
      this.initTwelve()
    	document.getElementById(this.tabCurrent).play();
    	$('#studytip-'+this.tabCurrent).hide();
    	$('#content-'+this.tabCurrent).hide();
    	$('#video-'+this.tabCurrent).show();
    	document.getElementById(this.tabCurrent).currentTime = 0
    },
    //开始实操练习
    startStudy() {
    	document.getElementById(this.tabCurrent).pause();
    	$('#stoptip-'+this.tabCurrent).hide();
			$('#video-'+this.tabCurrent).hide();
    	this.isShowBtn[this.tabCurrent] = false
    	$('#content-'+this.tabCurrent).show();
    	this.addRecord('START')
        // this.getFocusbc_1()
    },
    //下一关
    studyNext(next) {
    	this.initFirst()
    	this.initSecond()
    	this.initThird()
    	this.initFour()
    	this.initFive()
    	this.initSix()
    	this.initSeven()
    	this.initEight()
    	this.initNine()
    	this.initTen()
    	this.initEleven()
    	this.initTwelve()
    	$('#studytip-'+this.tabCurrent).hide();
    	$('#content-'+this.tabCurrent).hide();
    	$('#video-'+this.tabCurrent).show();
    	document.getElementById(this.tabCurrent).currentTime = 0
    	$(next).click();
    },
    //第1步-鼠标移入输入法
    showLoginqh1_1(){
        this.isShowqh1_1=false
        this.isShowqh1_2=true

    },
    //鼠标点击输入法
    showLoginqh1_2(){
        this.isShowqh1_2=false
        this.isShowqh1_3=true

    },
    //鼠标移入搜狗输入法
    showLoginqh1_3(){
        this.isShowqh1_3=false
        this.isShowqh1_4=true

    },
    //鼠标点击搜狗输入法
    showLoginqh1_4(){
        this.isShowqh1_4=false
        this.isShowqh1_5=true
        // 设置截屏页面显示
        setTimeout(() => {
           this.isShowqh1_5=false
           this.isShowjp1_1=true

        }, 2000);

    },
     //鼠标移入输入法设置
    showLoginjp1_1(){
        this.isShowjp1_1=false
        this.isShowjp1_2=true

    },
     //鼠标点击输入法设置
    showLoginjp1_2(){
        this.isShowjp1_2=false
        this.isShowjp1_3=true

    },
     //鼠标移入截屏设置
    showLoginjp1_3(){
        this.isShowjp1_3=false
        this.isShowjp1_4=true

    },
   
     //点击鼠标右键
    showLoginjp1_4(){
        this.isShowjp1_4=false
        this.isShowjp1_5=true

    },
     //鼠标点击发送到桌面
    showLoginjp1_5(){
        this.isShowjp1_5=false
        this.isShowjp1_6=true
        // 设置截屏快捷键页面显示
        setTimeout(() => {
            this.isShowjp1_6=false
            this.isShowkj1_1=true
        }, 2000);

    },
	//鼠标移入输入法
	showLoginkj1_1(){
		this.isShowkj1_1=false
		this.isShowkj1_2=true
	},
	//鼠标点击输入法菜单
	showLoginkj1_2(){
		this.isShowkj1_2=false
		this.isShowkj1_3=true
	},
	//鼠标点击更多设置
	showLoginkj1_3(){
		this.isShowkj1_3=false
		this.isShowkj1_4=true
	},
	//鼠标移入按键
	showLoginkj1_4(){
		this.isShowkj1_4=false
		this.isShowkj1_5=true
	},
	//鼠标点击按键
	showLoginkj1_5(){
		this.isShowkj1_5=false
		this.isShowkj1_6=true
	},
	// //滚轮滑动
	// gunlun(e){
	// 	console.log(e)
	// 	if(e.deltaY>0){
	// 		this.isShowkj1_6=false
	// 		this.isShowkj1_7=true
	// 	}
	// },
	//鼠标移入系统功能快捷键设置
	showLoginkj1_6(){
			this.isShowkj1_6=false
			this.isShowkj1_8=true	
	},
	//鼠标点击系统功能快捷键设置
	showLoginkj1_7(){
			this.isShowkj1_8=false
			this.isShowkj1_9=true	
	},
	// //滚轮滑动
	// showLoginkj1_8(e){
	// 	if(e.deltaY>0){
	// 		this.isShowkj1_9=false
	// 		this.isShowkj1_10=true
	// 	}
	// },
	//鼠标移入截屏
	showLoginkj1_9(){
			this.isShowkj1_9=false
			this.isShowkj1_11=true
	},
	//鼠标点击截屏单选框
	showLoginkj1_10(){
			this.isShowkj1_11=false
			this.isShowkj1_12=true
			var self = this
			this.addRecord('END')
    	setTimeout(function() {
        $('#studytip-'+self.tabCurrent).show();
      }, 2000);
	},
   
	// 搜狗输入法的快捷短语
	// 搜狗输入法的快捷短语的第一张图显示// 鼠标移入高级
   showLogindy1_1(){
	   this.isShowdy1_1=false
	   this.isShowdy1_2=true
   },
	// 鼠标点击高级
   showLogindy1_2(){
	   this.isShowdy1_2=false
	   this.isShowdy1_3=true
   },
	//鼠标移入自定义短语设置
   showLogindy1_3(){
	 
			this.isShowdy1_3=false
			this.isShowdy1_4=true
	
   },
	//鼠标点击自定义短语设置
   showLogindy1_4(){
	  		this.isShowdy1_4=false
			this.isShowdy1_5=true
   },
	//鼠标移入添加新短语
   showLogindy1_5(){
	  		this.isShowdy1_5=false
			this.isShowdy1_6=true
   },
	//鼠标点击添加新短语
   showLogindy1_6(){
	  		this.isShowdy1_6=false
			this.isShowdy1_7=true
   },
	//鼠标点击确定并继续添加
   showLogindy1_7(){
	  		if(this.isShowdy1_7_input!='bb'){
				 this.notify('<p>请将“缩写”按照要求编辑</p>')
				  
			  }else{
				  if(this.isShowdy1_7_textarea!='报备：去上厕所，离开3分钟'){
					  this.notify('<p>请将“内容”按照要求编辑</p>')
				  }else{
					  
					  this.isShowdy1_7=false
					  this.isShowdy1_7_input=''
					  this.isShowdy1_7_textarea=''
					  this.isShowdy1_8=true

				  }
			  }
		
   },
	//鼠标点击确定
   showLogindy1_8(){
	  		if(this.isShowdy1_7_input!='bb'){
				 this.notify('<p>请将“缩写”按照要求编辑</p>')
				  
			  }else{
				  if(this.isShowdy1_7_textarea!='报备：去上厕所，离开5分钟'){
					  this.notify('<p>请将“内容”按照要求编辑</p>')
				  }else{
					  if(this.isShowdy1_7_select!=2){
						   this.notify('<p>请将“候选位置”按照要求编辑</p>')
					  }else{
						this.isShowdy1_8=false
					  	this.isShowdy1_9=true
						//   延时两秒显示调用页面
						setTimeout(() => {
							this.isShowdy1_9=false
							this.isShowdy1_10=true
						}, 2000);
					  }
					

				  }
			  }
		
   },
   //连续点击两次b
   showLogindy1_9(){
	   this.isShowdy1_10=false
	   this.isShowdy1_11=true
   },
   //鼠标移到2
   showLogindy1_10(){
	   this.isShowdy1_11=false
	   this.isShowdy1_12=true
   },
   //键盘按下2
   showLogindy1_10_1(){
	   this.isShowdy1_11=false
	   this.isShowdy1_13=true
   },
   //鼠标点击2
   showLogindy1_11(){
	   this.isShowdy1_12=false
	   this.isShowdy1_13=true
   },
   //鼠标点击发送
   showLogindy1_12(){
	   this.isShowdy1_13=false
	   this.isShowdy1_14=true
	   	var self = this
		this.addRecord('END')
    	setTimeout(function() {
        $('#studytip-'+self.tabCurrent).show();
      }, 2000);
   },
   //按下键盘enter
   showLogindy1_12_1(){
	   this.isShowdy1_13=false
	   this.isShowdy1_14=true
	   	var self = this
		this.addRecord('END')
    	setTimeout(function() {
        $('#studytip-'+self.tabCurrent).show();
      }, 2000);
   },



   
	// 点击第六行第三个
	showLoginImg10(){
		var self = this
		this.isShowQnIcon13 = false
		this.isShowQnIcon14 = true
		this.addRecord('END')
	
		
    	setTimeout(function() {
        $('#studytip-'+self.tabCurrent).show();
      }, 2000);
	},
	//重练第1步-Excel界面介绍
	restartStudyFirst() {
    	this.initFirst()
      $('#studytip-'+this.tabCurrent).hide();
      this.addRecord('START')
    },
    // //登录
    // loginIn() {
    //   if(this.name == '') {
    //     this.notify('<p>请输入账号</p>')
    //     return
    //   }else if(this.name != '淘金客服:001') {
    //     this.notify('<p>用户名或密码错误</p>'+'<p>请注意大小写或特殊符号</p>')
    //     return
    //   }
    //   if(this.password == '') {
    //     this.notify('<p>请输入密码</p>')
    //     return
    //   }else if(this.password != 'TJ2019') {
    //     this.notify('<p>用户名或密码错误</p>'+'<p>请注意大小写或特殊符号</p>')
    //     return
    //   }
    //   this.isShowLoginImg = false
    //   this.isShowRnd = true
    // },
    // //验证码登录
    // loginInRnd() {
    // 	if(this.rnd == '') {
    //     this.notify('<p>请输入短信验证码</p>')
    //     return
    //   }else if(this.rnd != '660220') {
    //     this.notify('<p>短信验证码错误</p>')
    //     return
    //   }
    //   this.isShowRnd = false
    //   this.isShowLoginIndex = true
    // },
    // //进入接待中心
    // enterJd() {
    // 	var self = this
    // 	this.isShowLoginIndex = false
    // 	this.isShowLoginIndexTwo = true
    // 	this.addRecord('END')
    // 	setTimeout(function() {
    //     $('#studytip-'+self.tabCurrent).show();
    //   }, 2000);
    // },
    // //重练-登录
    // restartStudyFirst() {
    // 	this.initFirst()
    // 	$('#studytip-'+this.tabCurrent).hide();
    // 	this.addRecord('START')
    // },
    //第2步-
    showLoginnr1_1() {
    	this.isShownr1_1=false
    	this.isShownr1_2=true
		this.getFocus()
    },
	//input自动获取焦点1
	getFocus(){
		this.$nextTick(function() {
			if (this.timer) {
			clearTimeout(this.timer);
			}
			this.timer = setTimeout(() => {
			this.$refs.strname.focus();
			}, 100);
		})
	},
	
	//监听回车1
	listenOne(event) {
	    if(event.keyCode === 13) {
		this.verification_nr1()
        event.preventDefault()
        return false
	    }
		},
	verification_nr1(){
		if(this.nr_input=='总分较8月上升（下降）'){
			this.isShownr1_2=false
    		this.isShownr1_3=true
			console.log(22222)
			setTimeout(()=>{
			this.isShownr1_3_1=true
			},2000)
		}else{
			this.notify('<p>请按照右边提示填写正确的内容</p>')
		}
	},
	//点击A3
	showLoginnr1_3(){
	    this.isShownr1_3=false
		
		this.isShownr1_4=true
		this.getFocus2()
	},
	//input自动获取焦点2
	getFocus2(){
		this.$nextTick(function() {
			if (this.timer) {
			clearTimeout(this.timer);
			}
			this.timer = setTimeout(() => {
			this.$refs.strname2.focus();
			}, 100);
		})
	},
	//监听回车2
	listenTwo(event){
    console.log(event,7777)
	console.log(event.key,555)
	if( event.key== ';' && event.ctrlKey) {
		    this.isShownr1_4=false
		    this.isShownr1_5=true
		    this.nr_input2=this.getNowDate()
			console.log(this.nr_input2,11111)
		    event.preventDefault()
		    return false
		    }
	},
	//监听回车3
	listenTwo_1(event){
		if(event.keyCode===13){
			if(this.nr_input2=='2022/9/29'){
				this.isShownr1_5=false
				this.isShownr1_6=true
			setTimeout(()=>{
				this.isShownr1_6_1=true
			},2000)
			}else{
				this.notify('<p>请按照右边提示填写正确的内容</p>')
			}
		}

	// if(  ) {
	// 	    this.isShownr1_4=false
	// 	    this.isShownr1_5=true
	// 	    this.nr_input2=this.getNowDate()
	// 		console.log(this.nr_input2,77777)
	// 	    event.preventDefault()
	// 	    return false
	// 	    }
	},
	// 获得当前时间（并格式化）
	getNowDate() {
      const timeOne = new Date()
      const year = timeOne.getFullYear()
      let month = timeOne.getMonth() + 1
      let day = timeOne.getDate()
      month = month < 10 ? '0' + month : month
      day = day < 10 ? '0' + day : day
      const NOW_MONTHS_AGO = `${year}/${month}/${day}`
      return NOW_MONTHS_AGO
    },
	// 点击A单元格（下拖前）
    showLoginnr1_6(){
		this.isShownr1_6=false
		this.isShownr1_6_1=false
		this.isShownr1_7=true
        // this.getFocus3()
	},
	
	//input自动获取焦点3
	getFocus3(){
		this.$nextTick(function() {
			if (this.timer) {
			clearTimeout(this.timer);
			}
			this.timer = setTimeout(() => {
			this.$refs.strname3.focus();
			}, 100);
		})
	},
	//监听ctrl+C
	listenTwo_2(event){
    console.log(event,7777)
	if( event.keyCode== 67 && event.ctrlKey ) {
		    this.showLoginnr1_7()
            event.preventDefault()
		    return false
		    }
	},
	// 按下 ctrl C
    showLoginnr1_7(){
		this.isShownr1_7=false
		this.isShownr1_8=true
		setTimeout(() => {
			this.isShownr1_8=false
			this.isShownr1_9=true
			// this.getFocus4()
		}, 1000);
		
		
		

	},
	//监听Ctrl+v 4
	// listenTwo_3(event){
    // console.log(event,77778888)
	// if( event.keyCode== 86) {
	// 	    this.isShownr1_9=false
	// 	    this.isShownr1_10=true
    //         setTimeout(()=>{
	// 			this.isShownr1_10=false
	// 			this.isShownr1_11=true
	// 		},2000)
    //         event.preventDefault()
	// 	    return false
	// 	    }
	// },
	//监听Ctrl+v 4
	listenTwo_3(){
		    this.isShownr1_9=false
		    this.isShownr1_10=true
            setTimeout(()=>{
				this.isShownr1_10=false
				this.isShownr1_11=true
			},2000) 
	},
	//input自动获取焦点4
	getFocus4(){
		this.$nextTick(function() {
			if (this.timer) {
			clearTimeout(this.timer);
			}
			this.timer = setTimeout(() => {
			this.$refs.strname4.focus();
			}, 100);
		})
	},
	//点击C列
	showLoginnr1_11(){
       this.isShownr1_11=false
       this.isShownr1_12=true
	},
	//点击鼠标右键
	rightClick($event){
		this.isShownr1_12=false
		this.isShownr1_13=true
	},
	//右键后鼠标移入插入列
	showLoginnr1_13(){
		this.isShownr1_13=false
		this.isShownr1_14=true
	},
	//点击鼠标移入的插入列
	showLoginnr1_14(){
		this.isShownr1_14=false
		this.isShownr1_15=true
		setTimeout(() => {
			this.isShownr1_15=false
        	this.isShownr1_16=true
		}, 2000);
	},
	//点击第6列
	showLoginnr1_15(){
		this.isShownr1_16=false
        this.isShownr1_17=true
	},
	//点击右键
	showLoginnr1_16(){
		// this.isShownr1_17=false
        // this.isShownr1_17_1=true
		this.isShownr1_17_1=true
	},
	//鼠标移入
	showLoginnr1_17(){
		this.isShownr1_17_1=false
		this.isShownr1_17_2=true
	},
	//点击插入行
	showLoginnr1_17_1(){
		this.isShownr1_17=false
		this.isShownr1_17_2=false
		this.isShownr1_18=true
		//过渡求和
		setTimeout(() => {
			this.isShownr1_18=false
			this.isShownr1_19=true
		}, 2000);
	},
	// 求和

	//点击I3
	showLoginnr1_19(){
		this.isShownr1_19=false
		this.isShowqh1_1=true
		this.getFocusqh_1()
	},
	//点击F3
	showLoginnr1_20(){
		if(this.qh1_input=='='){
			this.qh1_input1='=F3'
			this.isShowqh1_1=false
			this.isShowqh1_2=true
			this.getFocusqh_2()
		}else{
			this.notify('<p>请按照右边提示填写正确的内容</p>')
		}
		
	},

	// 点击下方的名字，进行修改
    Loginxg1_3(){
        this.isShowxg1_1=false
		this.isShowxg1_2=true
    },
	//修改完点击enter
	showLoginxg1_1(){
    if(this.xg_input1=='成绩汇总'){
		this.isShowxg1_2=false
		this.isShowxg1_3=true
		// 显示新建页面
		setTimeout(() => {
			this.isShowxg1_3=false
			this.isShowxj1_1=true
		}, 2000);
	}else{
		this.notify('<p>请按照右边提示填写正确的内容</p>')
	}
	},
	// 移入+号
	Loginxj1_1(){
		this.isShowxj1_1=false
		this.isShowxj1_2=true
	},
	// 点击+号
	Loginxj1_2(){
		this.isShowxj1_2=false
		this.isShowxj1_3=true
		// 显示占比页面
		setTimeout(() => {
			this.isShowxj1_3=false
			this.isShowzb1_1=true
		}, 2000);
	},
	//点击C3
	Loginzb1_1(){
		this.isShowzb1_1=false
		this.isShowzb1_2=true
		this.getFocuszb_1()
	},
	// 点击B3
	Loginzb1_2(){
		if(this.zb_input1=='='){
			this.zb_input1='=B3'
			this.isShowzb1_2=false
			this.isShowzb1_3=true
			this.getFocuszb_1()
		}else{
			this.notify('<p>请按照右边提示填写正确的内容</p>')
		}
		
	},
	//输入框焦点聚焦
	getFocuszb_1(){
		this.$nextTick(function() {
			if (this.timer) {
			clearTimeout(this.timer);
			}
			this.timer = setTimeout(() => {
			this.$refs.strname_zb1.focus();
			}, 100);
		})
	},
	
	//点击A3
	Loginzb1_3(){
		if(this.zb_input1=='=B3/'){
			this.isShowzb1_3=false
			this.isShowzb1_4=true

		}else{
			this.notify('<p>请按照右边提示填写正确的内容</p>')
		}
		
		// this.getFocuszb_1()
	},
	//按下enter
	showLoginzb1_1(){
		this.isShowzb1_4=false
		this.isShowzb1_5=true
		//第二张修改页面
		setTimeout(()=>{
			this.isShowzb1_5=false
			this.isShowxg2_1=true
		},2000)
	},
	//输入框焦点聚焦
	getFocusxg_2(){
		this.$nextTick(function() {
			if (this.timer) {
			clearTimeout(this.timer);
			}
			this.timer = setTimeout(() => {
			this.$refs.strname_xg2.focus();
			}, 100);
		})
	},
	//点击下面的sheet2
	Loginxg2_1(){
		this.isShowxg2_1=false
		this.isShowxg2_2=true
		this.getFocusxg_2()
	},
	//按下enter
	showLoginxg2_1(){

        if(this.xg_input2=='数据统计'){
			var self = this
			this.isShowxg2_2=false
			this.isShowxg2_3=true
			this.addRecord('END')
			setTimeout(function() {
			$('#studytip-'+self.tabCurrent).show();
      	}, 2000);
		}else{
			this.notify('<p>请按照右边提示填写正确的内容</p>')
		}
	},
    //重练-Excel内容编辑
    restartStudySecond() {
    	this.initSecond()
			$('#studytip-'+this.tabCurrent).hide();
			this.addRecord('START')
    },

    // 第3步-Excel内容布局 

	//鼠标移入字体样式
    Loginzt1_1(){
        this.isShowzt1_1=false
		this.isShowzt1_2=true
	},
	//鼠标点击字体样式
	Loginzt1_2(){
		this.isShowzt1_2=false
		this.isShowzt1_3=true
	},
	//鼠标移入微软雅黑
	Loginzt1_3(){
		this.isShowzt1_3=false
		this.isShowzt1_4=true
		// this.isShowzt1_3=true
	},
	//鼠标点击微软雅黑
	Loginzt1_4(){
		this.isShowzt1_4=false
		this.isShowzt1_5=true
		// 显示居中页面
		setTimeout(()=>{
			this.isShowzt1_5=false
			this.isShowjz1_1=true
		},2000)
	},
	//鼠标移入居中
	Loginjz1_1(){
		this.isShowjz1_1=false
		this.isShowjz1_2=true
	},
	//鼠标点击居中
	Loginjz1_2(){
		this.isShowjz1_2=false
		this.isShowjz1_3=true
		// 显示框线页面
		setTimeout(() => {
			this.isShowjz1_3=false
			this.isShowkx1_1=true
		}, 2000);
	},
    // 鼠标移入框线
	Loginkx1_1(){
		this.isShowkx1_1=false
		this.isShowkx1_2=true
	},
	//鼠标点击框线
	Loginkx1_2(){
		this.isShowkx1_2=false
		this.isShowkx1_3=true
	},
	//鼠标移入所有框线
	Loginkx1_3(){
		this.isShowkx1_3=false
		this.isShowkx1_4=true
	},
	//鼠标点击所有框线
	Loginkx1_4(){
		this.isShowkx1_4=false
		this.isShowkx1_5=true
		// 调整A页面显示
		setTimeout(() => {
			this.isShowkx1_5=false
			this.isShowta1_2=true
		}, 2000);
	},
	// //点击A列
	// Loginta1_1(){
	// 	this.isShowta1_1=false
	// 	this.isShowta1_2=true
	// },
	//鼠标移入ab列间
	Loginta1_2(){
		this.isShowta1_2=false
		this.isShowta1_3=true
		// 显示加粗合并第一行页面
		setTimeout(() => {
			this.isShowta1_3=false
			this.isShowjchb1_1=true
		}, 2000);
		
	},
	//鼠标移入字体加粗
	Loginjchb1_1(){
		this.isShowjchb1_1=false
		this.isShowjchb1_2=true
	},
	//鼠标点击字体加粗（第一次）
	Loginjchb1_2(){
		this.isShowjchb1_2=false
		this.isShowjchb1_3=true
	},
	//鼠标点击字体加粗（第二次）
	Loginjchb1_3(){
		this.isShowjchb1_3=false
		this.isShowjchb1_4=true
	},
	//鼠标移入加粗
	Loginjchb1_4(){
		this.isShowjchb1_4=false
		this.isShowjchb1_5=true
	},
	//鼠标点击加粗
	Loginjchb1_5(){
		this.isShowjchb1_5=false
		this.isShowjchb1_6=true
	},
	//鼠标移入合并居中
	Loginjchb1_6(){
		this.isShowjchb1_6=false
		this.isShowjchb1_7=true
	},
	//鼠标点击合并居中
	Loginjchb1_7(){
		this.isShowjchb1_7=false
		this.isShowjchb1_8=true
	},
    //鼠标移入设置颜色
	Loginjchb1_8(){
		this.isShowjchb1_8=false
		this.isShowjchb1_9=true
	},
    //鼠标点击设置颜色
	Loginjchb1_9(){
		this.isShowjchb1_9=false
		this.isShowjchb1_10=true
	},
    //鼠标移到颜色
	Loginjchb1_10(){
		this.isShowjchb1_10=false
		this.isShowjchb1_11=true
	},
    //鼠标点击颜色
	Loginjchb1_11(){
		this.isShowjchb1_11=false
		this.isShowjchb1_12=true
		//第二行颜色换行页面显示
		setTimeout(() => {
			this.isShowjchb1_12=false
			this.isShowyshh1_1=true
		}, 2000);
	},
    //鼠标移入字体颜色的A
	Loginyshh1_1(){
        this.isShowyshh1_1=false
		this.isShowyshh1_2=true
	},
    //鼠标点击字体颜色的A
	Loginyshh1_2(){
        this.isShowyshh1_2=false
		this.isShowyshh1_3=true
	},
	//鼠标移到自动换行
	Loginyshh1_3(){
		this.isShowyshh1_3=false
		this.isShowyshh1_4=true
	},
	//鼠标点击自动换行
	Loginyshh1_4(){
		this.isShowyshh1_4=false
		this.isShowyshh1_5=true
		// 显示冻结页面
		setTimeout(() => {
			this.isShowyshh1_5=false
			this.isShowdj1_1=true
		}, 2000);
	},
    //鼠标移入冻结窗格
	Logindj1_1(){
		this.isShowdj1_1=false
		this.isShowdj1_2=true
	},
    //鼠标点击冻结窗格
	Logindj1_2(){
		this.isShowdj1_2=false
		this.isShowdj1_3=true
	},
    //鼠标移入冻结至第二行
	Logindj1_3(){
		this.isShowdj1_3=false
		this.isShowdj1_4=true
	},
    //鼠标点击冻结至第二行
	Logindj1_4(){
		this.isShowdj1_4=false
		this.isShowdj1_5=true
		// 保留小数页面显示
		setTimeout(() => {
			this.isShowdj1_5=false
			this.isShowxs1_1=true
		}, 2000);

	},
	//鼠标移入常规
	Loginxs1_1(){
		this.isShowxs1_1=false
		this.isShowxs1_2=true
	},
	//鼠标点击常规下箭头
	Loginxs1_2(){
		this.isShowxs1_2=false
		this.isShowxs1_3=true
	},
	//鼠标移入其他数字格式
	Loginxs1_3(){
		this.isShowxs1_3=false
		this.isShowxs1_4=true
	},
	//鼠标点击其他数字格式
	Loginxs1_4(){
		this.isShowxs1_4=false
		this.isShowxs1_5=true
	},
	// 点击数值
	Loginxs1_5(){
		this.isShowxs1_5=false
		this.isShowxs1_6=true
	},
	// 鼠标移入输入框
	Loginxs1_6(){
		this.isShowxs1_6=false
		this.isShowxs1_7=true
	},
	// 鼠标点击减号输入框
	Loginxs1_7(){
		this.isShowxs1_7=false
		this.isShowxs1_8=true
	},
	// 鼠标移动到确定
	Loginxs1_8(){
		this.isShowxs1_8=false
		this.isShowxs1_9=true
	},
	// 鼠标点击确定
	Loginxs1_9(){
		this.isShowxs1_9=false
		this.isShowxs1_10=true
		// 占比保留页面显示
		setTimeout(() => {
			this.isShowxs1_10=false
			this.isShowzbbl1_1=true
		},2000);
	},
	//鼠标移入常规
	Loginzbbl1_1(){
		this.isShowzbbl1_1=false
		this.isShowzbbl1_2=true
	},
	//鼠标点击常规
	Loginzbbl1_2(){
		this.isShowzbbl1_2=false
		this.isShowzbbl1_3=true
	},
	//鼠标移动到%
	Loginzbbl1_3(){
		this.isShowzbbl1_3=false
		this.isShowzbbl1_4=true
	},
	//鼠标移动到%
	Loginzbbl1_4(){
		this.isShowzbbl1_3=false
		this.isShowzbbl1_4=true
	},
	//鼠标点击%
	Loginzbbl1_4(){
		let self = this
		this.isShowzbbl1_4=false
		this.isShowzbbl1_5=true
		this.addRecord('END')
    	setTimeout(function() {
        $('#studytip-'+self.tabCurrent).show();
      }, 2000);
	},
	//重练第三步-Excel内容布局
    restartStudyThird() {
    	this.initThird()
			$('#studytip-'+this.tabCurrent).hide();
			this.addRecord('START')
    },
	// 第四步 保存文件
	//输入框焦点聚焦
	getFocusbc_1(){
		this.$nextTick(function() {
			if (this.timer) {
			clearTimeout(this.timer);
			}
			this.timer = setTimeout(() => {
			this.$refs.strname_bc1.focus();
			}, 100);
		})
	},
    // // 监听etrl+s
	// showLoginbc1_1(event){
	
    // console.log(event,77778888)
	// if( event.keyCode== 83) {
		
	// 	    this.isShowbc1_1=false
	// 	    this.isShowbc1_2=true
          
    //         event.preventDefault()
	// 	    return false
	// 	    }
	// },
    // 监听etrl+s
	showLoginbc1_1(event){
	
		this.isShowbc1_1=false
		this.isShowbc1_2=true
          
		   
	},
	// 鼠标移入我的桌面
	Loginbc1_1(){
		this.isShowbc1_2=false
		this.isShowbc1_3=true
	},
	// 鼠标移入我的桌面
	Loginbc1_2(){
		this.isShowbc1_3=false
		this.isShowbc1_4=true
	},
	// 鼠标移入办公软件培训
	Loginbc1_3(){
		this.isShowbc1_4=false
		this.isShowbc1_5=true
	},
	// 鼠标点击办公软件培训
	Loginbc1_4(){
		this.isShowbc1_5=false
		this.isShowbc1_6=true
	},
	// 鼠标点击文件名
	Loginbc1_5(){
		this.isShowbc1_6=false
		this.isShowbc1_7=true
	},
	//输入框焦点聚焦
	getFocusbc_2(){
		this.$nextTick(function() {
			if (this.timer) {
			clearTimeout(this.timer);
			}
			this.timer = setTimeout(() => {
			this.$refs.strname_bc2.focus();
			}, 100);
		})
	},
	//第二次点击文件名
	Loginbc1_6(){
		this.isShowbc1_7=false
		this.isShowbc1_8=true
		this.getFocusbc_2()
	},
	// 鼠标点击文件名
	Loginbc1_7(){
		if(this.bc_input2=='月考成绩统计'){
			this.isShowbc1_8=false
			this.isShowbc1_9=true
			//显示另存页面
			setTimeout(() => {
				this.isShowbc1_9=false
				this.isShowlc1_1=true
			}, 2000);
		}else{
			this.notify('<p>请填写月考成绩统计</p>')
		}
		
	},
	// 监听另存点击右键
	Loginlc1_1(){
		console.log(8899)
		this.isShowlc1_1=false
		this.isShowlc1_2=true
	},
	//鼠标移入另存为
	Loginlc1_2(){
		this.isShowlc1_2=false
		this.isShowlc1_3=true
	},
	//鼠标点击另存为
	Loginlc1_3(){
		this.isShowlc1_3=false
		this.isShowlc1_4=true	
	},
	//鼠标移入我的桌面
	Loginlc1_4(){
		this.isShowlc1_4=false
		this.isShowlc1_5=true	
	},
	//鼠标点击我的桌面
	Loginlc1_5(){
		this.isShowlc1_5=false
		this.isShowlc1_6=true	
	},
	//鼠标点击保存
	Loginlc1_6(){
		var self = this
		this.isShowlc1_6=false
		this.isShowlc1_7=true
		this.addRecord('END')
    	setTimeout(function() {
        $('#studytip-'+self.tabCurrent).show();
      }, 2000);	
	},
	//重练第4步-保存文件
    restartStudyFour() {
    	this.initFour()
      $('#studytip-'+this.tabCurrent).hide();
      this.addRecord('START')
    },
	//第五步保存文件
	// 鼠标移入关闭
	Loginfs1_1(){
		this.isShowfs1_1=false
		this.isShowfs1_2=true
	},
	// 鼠标移入关闭
	Loginfs1_1(){
		this.isShowfs1_1=false
		this.isShowfs1_2=true
	},
	// 鼠标点击关闭
	Loginfs1_2(){
		this.isShowfs1_2=false
		this.isShowfs1_3=true
	},
	// 鼠标点击表格
	Loginfs1_3(){
		this.isShowfs1_3=false
		this.isShowfs1_4=true
	},
	// 按下etrl+c
	Loginfs1_4(){
		this.isShowfs1_4=false
		this.isShowfs1_5=true
	},
	// 按下etrl+v
	Loginfs1_5(){
		this.isShowfs1_5=false
		this.isShowfs1_6=true
	},
	// 点击发送
	Loginfs1_6(){
		var self = this
		this.isShowfs1_6=false
		this.isShowfs1_7=true
		this.addRecord('END')
    	setTimeout(function() {
        $('#studytip-'+self.tabCurrent).show();
      }, 2000);
	},
	// 第六步
	//ctrl+A
	Loginwdzt1_1(){
		this.isShowwdzt1_1=false
		this.isShowwdzt1_2=true
	},
	//鼠标移入字体下拉
	Loginwdzt1_2(){
		this.isShowwdzt1_2=false
		this.isShowwdzt1_3=true
	},
	//鼠标点击字体下拉
	Loginwdzt1_3(){
		this.isShowwdzt1_3=false
		this.isShowwdzt1_4=true
	},
	//鼠标移入楷体
	Loginwdzt1_4(){
		this.isShowwdzt1_4=false
		this.isShowwdzt1_5=true
	},
	//鼠标点击楷体
	Loginwdzt1_5(){
		this.isShowwdzt1_5=false
		this.isShowwdzt1_6=true
	},
	//鼠标移入字号
	Loginwdzt1_6(){
		this.isShowwdzt1_6=false
		this.isShowwdzt1_7=true
	},
	//鼠标点击字号
	Loginwdzt1_7(){
		this.isShowwdzt1_7=false
		this.isShowwdzt1_8=true
	},
	//鼠标移入小四
	Loginwdzt1_8(){
		this.isShowwdzt1_8=false
		this.isShowwdzt1_9=true
	},
	//鼠标点击小四
	Loginwdzt1_9(){
		this.isShowwdzt1_9=false
		this.isShowwdzt1_10=true
	},
	//鼠标点击小四
	Loginwdzt1_9(){
		this.isShowwdzt1_9=false
		this.isShowwdzt1_10=true
		// 显示行距页面
		setTimeout(() => {
			this.isShowwdzt1_10=false
			this.isShowwdhj1_1=true
		}, 2000);
	},
	// 移入行距
	Loginwdhj1_1(){
		this.isShowwdhj1_1=false
		this.isShowwdhj1_2=true
	},
	// 点击行距
	Loginwdhj1_2(){
		this.isShowwdhj1_2=false
		this.isShowwdhj1_3=true
	},
	// 鼠标移入1.5
	Loginwdhj1_3(){
		this.isShowwdhj1_3=false
		this.isShowwdhj1_4=true
	},
	// 鼠标点击1.5
	Loginwdhj1_4(){
		this.isShowwdhj1_4=false
		this.isShowwdhj1_5=true
		// 显示首行缩进页面
		setTimeout(() => {
			this.isShowwdhj1_5=false
			this.isShowwdsj1_1=true	
		}, 2000);
	},
	// 点击鼠标右键
	rightClick_sj(){
		this.isShowwdsj1_1_1=true
	},
	//鼠标移入段落
	Loginwdsj1_1(){
		this.isShowwdsj1_1=false
		this.isShowwdsj1_2=true
	},
	//鼠标点击段落
	Loginwdsj1_2(){
		this.isShowwdsj1_2=false
		this.isShowwdsj1_3=true
	},
	//鼠标点击特殊格式
	Loginwdsj1_3(){
		this.isShowwdsj1_3=false
		this.isShowwdsj1_4=true
	},
	//鼠标移动到首行缩进
	Loginwdsj1_4(){
		this.isShowwdsj1_4=false
		this.isShowwdsj1_5=true
	},
	//鼠标点击首行缩进
	Loginwdsj1_5(){
		this.isShowwdsj1_5=false
		this.isShowwdsj1_6=true
	},
	//鼠标点击确定
	Loginwdsj1_6(){
		this.isShowwdsj1_6=false
		this.isShowwdsj1_7=true
		// 显示加粗居中页面
		setTimeout(() => {
			this.isShowwdsj1_7=false
			this.isShowwdjc1_1=true	
		}, 2000);
	},
	// 鼠标移到加粗
	Loginwdjc1_1(){
		this.isShowwdjc1_1=false
		this.isShowwdjc1_2=true	
	},
	// 鼠标点击加粗
	Loginwdjc1_2(){
		this.isShowwdjc1_2=false
		this.isShowwdjc1_3=true	
	},
	// 鼠标移到居中
	Loginwdjc1_3(){
		this.isShowwdjc1_3=false
		this.isShowwdjc1_4=true	
	},
	// 鼠标点击居中
	Loginwdjc1_4(){
		this.isShowwdjc1_4=false
		this.isShowwdjc1_5=true	
		// 设置颜色页面显示
		setTimeout(() => {
			this.isShowwdjc1_5=false
			this.isShowwdys1_1=true	
		}, 2000);
	},
	// 鼠标移到颜色
	Loginwdys1_1(){
		this.isShowwdys1_1=false
		this.isShowwdys1_2=true	
	},
	// 鼠标点击颜色
	Loginwdys1_2(){
		this.isShowwdys1_2=false
		this.isShowwdys1_3=true	
	},
	// 鼠标移到红色
	Loginwdys1_3(){
		this.isShowwdys1_3=false
		this.isShowwdys1_4=true	
	},
	// 鼠标点击红色
	Loginwdys1_4(){
		this.isShowwdys1_4=false
		this.isShowwdys1_5=true	
		// 自然段颜色页面显示
		setTimeout(() => {
			this.isShowwdys1_5=false
			this.isShowwdtx1_1=true	
		}, 2000);
	},
	//鼠标移入段落颜色
	Loginwdtx1_1(){
		this.isShowwdtx1_1=false
		this.isShowwdtx1_2=true
	},
	//鼠标点击段落颜色
	Loginwdtx1_2(){
		this.isShowwdtx1_2=false
		this.isShowwdtx1_3=true
	},
	//鼠标点击空白
	Loginwdtx1_3(){
		let self = this
		this.isShowwdtx1_3=false
		this.isShowwdtx1_4=true
		this.addRecord('END')
    	setTimeout(function() {
        $('#studytip-'+self.tabCurrent).show();
      }, 2000);
	},
	// 重新练习Word基础功能
	 restartStudySix() {
    	this.initSix()
      $('#studytip-'+this.tabCurrent).hide();
      this.addRecord('START')
    },
	// //鼠标点击保存
	// Loginlc1_4(){
	// 	this.isShowlc1_5=false
	// 	this.isShowlc1_6=true	
	// },
	// //鼠标点击常规下箭头
	// Loginxs1_3(){
	// 	this.isShowxs1_2=false
	// 	this.isShowxs1_3=true
	// },
    //监听回车1
    
		//监听回车3
		listenThree() {
			if(event.keyCode === 13) {
        this.showJieDaiImgThree()
        event.preventDefault()
        return false
	    }
		},
		//监听回车4
		listenFour() {
			if(event.keyCode === 13) {
        this.showJieDaiImgFour()
        event.preventDefault()
        return false
	    }
		},
    //接待顾客-显示回复1
    showJieDaiImgOne() {
    	let self = this
    	if(this.jdnr.indexOf('您好')<0 || this.jdnr.indexOf('欢迎光临')<0 || this.jdnr.indexOf('请问有什么可以帮到您')<0) {
        this.notify('<p>请按照右边提示输入正确的回复内容</p>')
        return
      }
      this.time1 = this.formatDate(new Date());
      this.replyhtml = "<p class='session'><span class='user'>fanchaocdmc</span><span class='time'>"+this.time+"</span></p><p><span>在吗？</span></p><p class='session'><span class='tjk'>淘金客服:001</span><span class='time'>"+this.time1+"</span></p><p><span>您好！欢迎光临，请问有什么可以帮到您？</span><span class='read'>已读</span></p>";
      $('.replyone').html(this.replyhtml);
      setTimeout(function() {
      	self.time2 = self.formatDate(new Date());
        self.replyhtml = "<p class='session'><span class='user'>fanchaocdmc</span><span class='time'>"+self.time+"</span></p><p><span>在吗？</span></p><p class='session'><span class='tjk'>淘金客服:001</span><span class='time'>"+self.time1+"</span></p><p><span>您好！欢迎光临，请问有什么可以帮到您？</span><span class='read'>已读</span></p><p class='session'><span class='user'>fanchaocdmc</span><span class='time'>"+self.time2+"</span></p><p><span>我今天下单的话，寄成都什么时候能收到呢？</span></p>";
        $('.replyone').html(self.replyhtml);
        setTimeout(function() {
        	self.isShowOne = false
    			self.isShowTwo = true
        }, 500);
      }, 2000);
    	this.jdnr = ''
    },
    //接待顾客-显示回复2
    showJieDaiImgTwo() {
    	let self = this
    	if(this.jdnr.indexOf('亲亲')<0 || this.jdnr.indexOf('正常情况下大概3天左右能到哦')<0) {
        this.notify('<p>请按照右边提示输入正确的回复内容</p>')
        return
      }
      this.time3 = this.formatDate(new Date());
      this.replyhtml = "<p class='session'><span class='user'>fanchaocdmc</span><span class='time'>"+this.time+"</span></p><p><span>在吗？</span></p><p class='session'><span class='tjk'>淘金客服:001</span><span class='time'>"+this.time1+"</span></p><p><span>您好！欢迎光临，请问有什么可以帮到您？</span><span class='read'>已读</span></p><p class='session'><span class='user'>fanchaocdmc</span><span class='time'>"+this.time2+"</span></p><p><span>我今天下单的话，寄成都什么时候能收到呢？</span></p><p class='session'><span class='tjk'>淘金客服:001</span><span class='time'>"+this.time3+"</span></p><p><span>亲亲，正常情况下大概3天左右能到哦！</span><span class='read'>已读</span></p>";
      $('.replyone').html(this.replyhtml);
      setTimeout(function() {
      	self.time4 = self.formatDate(new Date());
        self.replyhtml = "<p class='session'><span class='user'>fanchaocdmc</span><span class='time'>"+self.time+"</span></p><p><span>在吗？</span></p><p class='session'><span class='tjk'>淘金客服:001</span><span class='time'>"+self.time1+"</span></p><p><span>您好！欢迎光临，请问有什么可以帮到您？</span><span class='read'>已读</span></p><p class='session'><span class='user'>fanchaocdmc</span><span class='time'>"+self.time2+"</span></p><p><span>我今天下单的话，寄成都什么时候能收到呢？</span></p><p class='session'><span class='tjk'>淘金客服:001</span><span class='time'>"+self.time3+"</span></p><p><span>亲亲，正常情况下大概3天左右能到哦！</span><span class='read'>已读</span></p><p class='session'><span class='user'>fanchaocdmc</span><span class='time'>"+self.time4+"</span></p><p><span>好的</span></p>";
        $('.replyone').html(self.replyhtml);
        setTimeout(function() {
        	self.isShowTwo = false
    			self.isShowThree = true
        }, 500);
      }, 2000);
    	this.jdnr = ''
    },
    //接待顾客-显示回复3
    showJieDaiImgThree() {
    	let self = this
    	if(this.jdnr.indexOf('请问还有什么可以帮到您')<0) {
        this.notify('<p>请按照右边提示输入正确的回复内容</p>')
        return
      }
      this.time5 = this.formatDate(new Date());
      this.replyhtml = "<p class='session'><span class='tjk'>淘金客服:001</span><span class='time'>"+this.time1+"</span></p><p><span>您好！欢迎光临，请问有什么可以帮到您？</span><span class='read'>已读</span></p><p class='session'><span class='user'>fanchaocdmc</span><span class='time'>"+this.time2+"</span></p><p><span>我今天下单的话，寄成都什么时候能收到呢？</span></p><p class='session'><span class='tjk'>淘金客服:001</span><span class='time'>"+this.time3+"</span></p><p><span>亲亲，正常情况下大概3天左右能到哦！</span><span class='read'>已读</span></p><p class='session'><span class='user'>fanchaocdmc</span><span class='time'>"+this.time4+"</span></p><p><span>好的</span></p><p class='session'><span class='tjk'>淘金客服:001</span><span class='time'>"+this.time5+"</span></p><p><span>请问还有什么可以帮到您？</span><span class='read'>已读</span></p>";
      $('.replyone').html(this.replyhtml);
      setTimeout(function() {
      	self.time6 = self.formatDate(new Date());
        self.replyhtml = "<p class='session'><span class='tjk'>淘金客服:001</span><span class='time'>"+self.time1+"</span></p><p><span>您好！欢迎光临，请问有什么可以帮到您？</span><span class='read'>已读</span></p><p class='session'><span class='user'>fanchaocdmc</span><span class='time'>"+self.time2+"</span></p><p><span>我今天下单的话，寄成都什么时候能收到呢？</span></p><p class='session'><span class='tjk'>淘金客服:001</span><span class='time'>"+self.time3+"</span></p><p><span>亲亲，正常情况下大概3天左右能到哦！</span><span class='read'>已读</span></p><p class='session'><span class='user'>fanchaocdmc</span><span class='time'>"+self.time4+"</span></p><p><span>好的</span></p><p class='session'><span class='tjk'>淘金客服:001</span><span class='time'>"+self.time5+"</span></p><p><span>请问还有什么可以帮到您？</span><span class='read'>已读</span></p><p class='session'><span class='user'>fanchaocdmc</span><span class='time'>"+self.time6+"</span></p><p><span>没有了</span></p>";
        $('.replyone').html(self.replyhtml);
        setTimeout(function() {
        	self.isShowThree = false
    			self.isShowFour = true
        }, 500);
      }, 2000);
    	this.jdnr = ''
    },
    //接待顾客-显示回复4
    showJieDaiImgFour() {
    	let self = this
    	if(this.jdnr.indexOf('好的')<0 || this.jdnr.indexOf('感谢亲亲的支持')<0 || this.jdnr.indexOf('祝您生活愉快')<0) {
        this.notify('<p>请按照右边提示输入正确的回复内容</p>')
        return
      }
      this.time7 = this.formatDate(new Date());
      this.replyhtml = "<p class='session'><span class='tjk'>淘金客服:001</span><span class='time'>"+this.time1+"</span></p><p><span>您好！欢迎光临，请问有什么可以帮到您？</span><span class='read'>已读</span></p><p class='session'><span class='user'>fanchaocdmc</span><span class='time'>"+this.time2+"</span></p><p><span>我今天下单的话，寄成都什么时候能收到呢？</span></p><p class='session'><span class='tjk'>淘金客服:001</span><span class='time'>"+this.time3+"</span></p><p><span>亲亲，正常情况下大概3天左右能到哦！</span><span class='read'>已读</span></p><p class='session'><span class='user'>fanchaocdmc</span><span class='time'>"+this.time4+"</span></p><p><span>好的</span></p><p class='session'><span class='tjk'>淘金客服:001</span><span class='time'>"+this.time5+"</span></p><p><span>请问还有什么可以帮到您？</span><span class='read'>已读</span></p><p class='session'><span class='user'>fanchaocdmc</span><span class='time'>"+this.time6+"</span></p><p><span>没有了</span></p><p class='session'><span class='tjk'>淘金客服:001</span><span class='time'>"+this.time7+"</span></p><p><span>好的，感谢亲亲的支持，祝您生活愉快</span><span class='read'>已读</span></p>";
      $('.replyone').html(this.replyhtml);
    	this.jdnr = ''
    	this.addRecord('END')
    	setTimeout(function() {
        $('#studytip-'+self.tabCurrent).show();
      }, 2000);
    },
    //重练第三步-接待顾客
    restartStudyThird() {
    	this.initThird()
			$('#studytip-'+this.tabCurrent).hide();
			this.addRecord('START')
    },
    //第4步-自动回复
    showZdhf01() {
    	this.isShowZdhficon = false
    	this.isShowZdhf01 = true
    	var $zdhficon = $('.zdhficon').closest('.con-left'),
        	height = $('.zdhficon').closest('.con-left')[0].scrollHeight;
    	setTimeout(() => {
        $zdhficon.scrollTop(height)
      }, 100)
    },
    showZdhf02() {
    	this.isShowZdhf01 = false
    	this.isShowZdhf02 = true
    },
    showZdhf03() {
    	this.isShowZdhf02 = false
    	this.isShowZdhf03 = true
    },
    showZdhf04() {
    	this.isShowZdhf03 = false
    	this.isShowZdhf04 = true
    },
    showZdhf05() {
    	this.isShowZdhf04 = false
    	this.isShowZdhf05 = true
    },
    showZdhf06() {
    	if(this.zdhf.indexOf('您好')<0 || this.zdhf.indexOf('欢迎光临')<0 || this.zdhf.indexOf('请问有什么可以帮到您')<0) {
        this.notify('<p>请按照右边提示输入正确的回复内容</p>')
        return
      }
    	this.isShowZdhf05 = false
    	this.zdhf = ''
    	this.isShowZdhf06 = true
    },
    showZdhf07() {
    	this.isShowZdhf06 = false
    	this.isShowZdhf07 = true
    },
    showZdhf08() {
    	this.isShowZdhf07 = false
    	this.isShowZdhf08 = true
    },
    showZdhf09() {
    	this.isShowZdhf08 = false
    	this.isShowZdhf09 = true
    },
    showZdhf10() {
    	let self = this
    	this.isShowZdhf09 = false
    	this.isShowZdhf10 = true
    	this.addRecord('END')
    	setTimeout(function() {
        $('#studytip-'+self.tabCurrent).show();
      }, 2000);
    },
    //重练第4步-自动回复
    restartStudyFour() {
    	this.initFour()
      $('#studytip-'+this.tabCurrent).hide();
      this.addRecord('START')
    },
    //第5步-插件学习
    // showCjxx01() {
    // 	this.isShowCjxxicon = false
    // 	this.isShowCjxx01 = true
    // },
    // showCjxx02() {
    // 	this.isShowCjxx01 = false
    // 	this.isShowCjxx02 = true
    // },
    // showCjxx03() {
    // 	this.isShowCjxx02 = false
    // 	this.isShowCjxx03 = true
    // 	this.isShowCjxxTip = false
    // 	this.isShowCjxxTip01 = true
    // },
    // showCjxx04() {
    // 	this.isShowCjxx03 = false
    // 	this.isShowCjxx04 = true
    // },
    // showCjxx05() {
    // 	this.isShowCjxx04 = false
    // 	this.isShowCjxx05 = true
    // },
    // showCjxx06() {
    // 	this.isShowCjxx05 = false
    //   this.isShowCjxx06 = true
    // },
    // showCjxx07() {
    // 	this.isShowCjxx06 = false
    //   this.isShowCjxx07 = true
    // },
    // showCjxx08() {
    // 	this.isShowCjxx07 = false
    // 	this.isShowCjxx08 = true
    // },
    // showCjxx09() {
    // 	this.isShowCjxx08 = false
    // 	this.isShowCjxx09 = true
    // },
    // showCjxx10() {
    // 	this.isShowCjxx09 = false
    //   this.isShowCjxx10 = true
    // },
    // showCjxx11() {
    // 	this.isShowCjxx10 = false
    // 	this.isShowCjxx11 = true
    // },
    // showCjxx12() {
    // 	this.isShowCjxx11 = false
    // 	this.isShowCjxx12 = true
    // },
    // showCjxx13() {
    // 	this.isShowCjxx12 = false
    // 	this.isShowCjxx13 = true
    // },
    // showCjxx14() {
    // 	this.isShowCjxx13 = false
    //   this.isShowCjxx14 = true
    // },
    // showCjxx15() {
    // 	this.isShowCjxx14 = false
    // 	this.isShowCjxx15 = true
    // },
    // showCjxx16() {
    // 	this.isShowCjxx15 = false
    // 	this.isShowCjxx16 = true
    // },
    // showCjxx17() {
    // 	this.isShowCjxx16 = false
    // 	this.isShowCjxx17 = true
    // },
    // showCjxx18() {
    // 	this.isShowCjxx17 = false
    // 	this.isShowCjxx18 = true
    // 	this.isShowCjxxTip01 = false
    // 	this.isShowCjxxTip02 = true
    // },
    // showCjxx19() {
    // 	this.isShowCjxx18 = false
    // 	this.isShowCjxx19 = true
    // },
    // showCjxx20() {
    // 	this.isShowCjxx19 = false
    //   this.isShowCjxx20 = true
    //   let self = this;
    //   this.addRecord('END')
    //   setTimeout(function() {
    //     $('#studytip-'+self.tabCurrent).show();
    //   }, 2000);
    // },
    //重练第5步-添加插件
    restartStudyFive() {
    	this.initFive()
      $('#studytip-'+this.tabCurrent).hide();
      this.addRecord('START')
    },
    //第6步-快捷短语
    showKjdy01() {
    	this.isShowKjdyicon = false
    	this.isShowKjdy01 = true
    },
    showKjdy02() {
    	this.isShowKjdy01 = false
    	this.isShowKjdy02 = true
    },
    showKjdy03() {
    	this.isShowKjdy02 = false
    	this.isShowKjdy03 = true
    },
    showKjdy04() {
    	let self = this
    	this.isShowKjdy03 = false
    	this.isShowKjdy04 = true
    	this.notify('<p>快捷短语鼠标点击练习完成，下一步快捷短语编码练习</p>')
    	setTimeout(function() {
        self.isShowKjdyTip01 = false
        self.isShowKjdyTip02 = true
        self.isShowKjdy04 = false
        self.isShowKjdy05 = true
      }, 2000);
    },
    showKjdy05() {
    	this.isShowKjdy05 = false
    	this.isShowKjdy06 = false
    	this.isShowKjdy07 = true
    },
    showKjdy06() {
    	let self = this
    	this.isShowKjdy07 = false
    	this.isShowKjdy08 = true
    	this.notify('<p>快捷短语编码练习完成，下一步快捷模板导入练习</p>')
    	setTimeout(function() {
        self.isShowKjdyTip02 = false
        self.isShowKjdyTip03 = true
        self.isShowKjdy08 = false
    		self.isShowKjdy09 = true
      }, 2000);
    },
    downloadKjdyFile() {
    	this.downCount = 1
    	// indow.open(('//taojinyun.file.itaojin.cn/qianniusource/快捷短语.csv'),"_blank")
		 let path = '//taojinyun.file.itaojin.cn/qianniusource/快捷短语.csv'
      const downloadRes = async () => {
          let response = await fetch(path); 
          let blob = await response.blob();  
          let objectUrl = window.URL.createObjectURL(blob);
          let a = document.createElement('a');
          a.href = objectUrl;
          a.download = '快捷短语.csv';
          a.click()
          a.remove(); 
       }
      downloadRes();

    	this.isShowKjdyTip03 = false
    	this.isShowKjdyTip04 = true
    },
    showKjdy07() {
    	if(this.downCount == 0) {
    		this.$alert('请先下载快捷短语模板')
    		return false
    	}
    	this.isShowKjdy09 = false
    	this.isShowKjdy10 = true
    },
    tirggerFile($event) {
    	let self = this
      var file = $event.target.files;
    	if(!file[0] || file[0] && file[0].name.indexOf('快捷短语')<0) {
    		this.$alert('请选择你下载的“快捷短语.csv”模板文件')
    		return false
    	}
    	setTimeout(function() {
        self.isShowKjdy10 = false
        self.isShowKjdy11 = true
      }, 500);
    },
    showKjdy08() {
    	let self = this
    	this.isShowKjdy11 = false
    	this.isShowKjdy12 = true
    	this.addRecord('END')
    	setTimeout(function() {
        $('#studytip-'+self.tabCurrent).show();
      }, 2000);
    },
    //重练第6步-快捷短语
    restartStudySix() {
    	this.initSix()
      $('#studytip-'+this.tabCurrent).hide();
      this.addRecord('START')
    },
    //第7步-状态识别
    showZtsb01() {
    	this.isShowZtsbicon = false
    	this.isShowZtsb01 = true
    },
    showZtsb02() {
    	this.isShowZtsb01 = false
      this.isShowZtsb02 = true
      this.isShowZtsbTip01 = false
      this.isShowZtsbTip02 = true
    },
    showZtsb03() {
    	this.isShowZtsb02 = false
      this.isShowZtsb03 = true
    },
    showZtsb04() {
    	this.isShowZtsb03 = false
      this.isShowZtsb04 = true
      this.isShowZtsbTip02 = false
      this.isShowZtsbTip03 = true
    },
    showZtsb05() {
    	this.isShowZtsb04 = false
      this.isShowZtsb05 = true
    },
    showZtsb06() {
    	this.isShowZtsb05 = false
      this.isShowZtsb06 = true
      let self = this
    	this.isShowKjdy11 = false
    	this.isShowKjdy12 = true
    	this.addRecord('END')
    	setTimeout(function() {
        $('#studytip-'+self.tabCurrent).show();
      }, 2000);
    },
    //重练第7步-状态识别
    restartStudySeven() {
    	this.initSeven()
      $('#studytip-'+this.tabCurrent).hide();
      this.addRecord('START')
    },
    //第8步-转接功能
    showZjgn01() {
    	this.isShowZjgnicon = false
    	this.isShowZjgn01 = true
    },
    showZjgn02() {
    	this.isShowZjgn01 = false
      this.isShowZjgn02 = true
      this.isShowZjgnTip01 = false
      this.isShowZjgnTip02 = true
    },
    showZjgn03() {
    	this.isShowZjgn02 = false
      this.isShowZjgn03 = true
    },
    showZjgn04() {
    	this.isShowZjgn03 = false
      this.isShowZjgn04 = true
    },
    showZjgn05() {
    	this.isShowZjgn04 = false
      this.isShowZjgn05 = true
      let self = this
    	this.addRecord('END')
    	setTimeout(function() {
        $('#studytip-'+self.tabCurrent).show();
      }, 2000);
    },
    //重练第8步-转接功能
    restartStudyEight() {
    	this.initEight()
      $('#studytip-'+this.tabCurrent).hide();
      this.addRecord('START')
    },
    //第9步-商品插件（推荐功能）
    showTjgn01() {
    	this.isShowTjgnicon = false
    	this.isShowTjgn01 = true
    },
    showTjgn02() {
    	this.isShowTjgn01 = false
      this.isShowTjgn02 = true
    },
    showTjgn03() {
    	this.isShowTjgn02 = false
      this.isShowTjgn03 = true
    },
    showTjgn04() {
    	this.isShowTjgn03 = false
      this.isShowTjgn04 = true
    },
    showTjgn05() {
    	this.isShowTjgn04 = false
      this.isShowTjgn05 = true
    },
    showTjgn06() {
    	this.isShowTjgn05 = false
      this.isShowTjgn06 = true
      let self = this
    	this.addRecord('END')
    	setTimeout(function() {
        $('#studytip-'+self.tabCurrent).show();
      }, 2000);
    },
    //重练第9步-商品插件
    restartStudyNine() {
    	this.initNine()
      $('#studytip-'+this.tabCurrent).hide();
      this.addRecord('START')
    },
    //第10步-订单插件
    showDdcj01() {
    	this.isShowDdcjicon = false
    	this.isShowDdcj01 = true
    },
    showDdcj02() {
    	if(this.ddcjbz == '') {
    		this.notify('<p>你还没有填写订单备注</p>')
        return;
    	}
      if(this.ddcjbz != '顾客要求发顺丰') {
        this.notify('<p>请按照右边提示填写正确的订单备注</p>')
        return;
      }
    	this.isShowDdcj01 = false
      this.isShowDdcj02 = true
      this.isShowDdcjTip02 = false
      this.isShowDdcjTip03 = true
    },
    showDdcj03() {
    	this.isShowDdcj02 = false
      this.isShowDdcj03 = true
    },
    showDdcj04() {
    	this.isShowDdcj03 = false
      this.isShowDdcj04 = true
    },
    showDdcj05() {
    	if(this.ddcjdz == '') {
    		this.notify('<p>你还没有填写地址</p>')
        return;
    	}
		console.log(this.ddcjdz)
		
    //   if(this.ddcjdz != '双流区大林镇') {
    //     this.notify('<p>请按照右边提示填写正确的地址</p>')
    //     return;
    //   }
      if(this.ddcjdz == "双流区 大林镇" || this.ddcjdz == "双流区大林镇" ) {
		 
      }else{
		   console.log(this.ddcjdz=='双流区 大林镇')
        this.notify('<p>请按照右边提示填写正确的地址</p>')
        return;
	  }
    	this.isShowDdcj04 = false
      this.isShowDdcj05 = true
    },
    showDdcj06() {
    	this.isShowDdcj05 = false
      this.isShowDdcj06 = true
    },
    showDdcj08() {
    	this.isShowDdcj10 = false
      this.isShowDdcj08 = true
    },
    showDdcj09() {
    	this.isShowDdcj08 = false
      this.isShowDdcj09 = true
    },
    showDdcj10() {
    	if(this.ddcjyf == '') {
    		this.notify('<p>你还没有填写邮费</p>')
        return;
    	}
      if(this.ddcjyf != '10') {
        this.notify('<p>请按照右边提示填写正确的邮费</p>')
        return;
      }
    	this.isShowDdcj09 = false
      this.isShowDdcjicon = true
      this.isShowDdcjTip01 = false
      this.isShowDdcjTip02 = true
    },
    showDdcj07() {
    	this.isShowDdcj06 = false
      this.isShowDdcj10 = true
      let self = this
    	this.addRecord('END')
    	setTimeout(function() {
        $('#studytip-'+self.tabCurrent).show();
      }, 2000);
    },
    //重练第10步-订单插件
    restartStudyTen() {
    	this.initTen()
      $('#studytip-'+this.tabCurrent).hide();
      this.addRecord('START')
    },
    //第11步-新建任务
    showXjrw01() {
    	this.isShowXjrwicon = false
    	this.isShowXjrw01 = true
    },
    showXjrw02() {
    	this.isShowXjrw01 = false
      this.isShowXjrw02 = true
    },
    showXjrw03() {
    	if(this.xjrwtxt.indexOf('此顾客有购买意向')<0 || this.xjrwtxt.indexOf('请继续跟进')<0) {
        this.notify('<p>请按照右边提示填写正确的任务内容</p>')
        return;
      }
    	this.isShowXjrw02 = false
      this.isShowXjrw03 = true
    },
    showXjrw04() {
    	this.isShowXjrw03 = false
      this.isShowXjrw04 = true
    },
    showXjrw05() {
    	this.isShowXjrw04 = false
      this.isShowXjrw05 = true
    },
    showXjrw06() {
      if(this.xjrwsj != this.xjrwmt) {
        this.notify('<p>请按照右边提示设置正确的时间</p>')
        return;
      }
    	this.isShowXjrw05 = false
      this.isShowXjrw06 = true
      let self = this
    	this.addRecord('END')
    	setTimeout(function() {
        $('#studytip-'+self.tabCurrent).show();
      }, 2000);
    },
    //重练第11步-新建任务
    restartStudyEleven() {
    	this.initEleven()
      $('#studytip-'+this.tabCurrent).hide();
      this.addRecord('START')
    },
    //第12步-退出千牛
    showTcqn01() {
    	this.isShowTcqnicon = false
    	this.isShowTcqn01 = true
    },
    showTcqn02() {
    	this.isShowTcqn01 = false
      this.isShowTcqn02 = true
      this.isShowTcqnTip01 = false
      this.isShowTcqnTip02 = true
    },
    showTcqn03() {
    	this.isShowTcqn02 = false
      this.isShowTcqn03 = true
    },
    showTcqn04() {
    	this.isShowTcqn03 = false
      this.isShowTcqn04 = true
    },
    showTcqn05() {
    	this.isShowTcqn04 = false
      this.isShowTcqn05 = true
      setTimeout(() => {
        var $left = $('.tcqn05icon').closest('.con-left');
        $left.scrollTop($left[0].scrollHeight)
      }, 100)
    },
    showTcqn06() {
    	this.isShowTcqn05 = false
      this.isShowTcqn06 = true
    },
    showTcqn07() {
    	this.isShowTcqn06 = false
    	this.isShowTcqn07 = true
    },
    showTcqn08() {
    	this.isShowTcqn07 = false
      this.isShowTcqn08 = true
    },
    showTcqn09() {
    	this.isShowTcqn08 = false
      this.isShowTcqn09 = true
    },
    showTcqn10() {
    	this.isShowTcqn09 = false
      this.isShowTcqn10 = true
      let self = this
    	this.addRecord('END')
    	setTimeout(function() {
        $('#studytip-'+self.tabCurrent).show();
      }, 2000);
    },
    /*
     * @description 时间格式化
     * @param { date } date 时间或时间戳
     * @param { string } format 格式化的字符串 eg: 'yyyy:MM:dd hh:mm:ss'
     *
     * @return { string } 格式化后的字符串
    */
    dateFormatString (date, format) { // 时间格式化
      var date = new Date(date),
        o = {
          "M+" : date.getMonth() + 1,
          "d+" : date.getDate(),
          "h+" : date.getHours(),
          "m+" : date.getMinutes(),
          "s+" : date.getSeconds(),
          "q+" : Math.floor((date.getMonth() + 3) / 3),
          "S" : date.getMilliseconds()
        };
      if (/(y+)/.test(format)) {
        format = format.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
      }
      
      for (var k in o) {
        if (new RegExp("(" + k + ")").test(format)) {
          format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
        }
      }
      return format;
    },
    /**
     * 获取从今日开始的前 n 天的日期
     */
    getLastDaysFromToday(n){
      let lastDays = new Date().setDate((new Date().getDate() - n));
      let lastDaysStr = this.dateFormatString(lastDays, 'yyyy-MM-dd');
      return lastDaysStr;
    },
    //记录接口
    addRecord(type) {
      var data = {
        exerciseType: 'SOUGOU_INPUT',
        stepSeq: this.tabIndex,
        exerciseAction: type
      }
      this.$http.post(API_ROOT.newcustomer + '/simulationExercise/addRecord', data).then(res=> {
        var result = res.data
        if(result.success) {
          if(this.tabIndex==2 && type=='END'){
		    window.parent['goBack']();
		  }
        }else {
          this.$message({
            message: result.msg,
            type: 'error',
            center: true,
            duration: 1000
          })
        }
      },res=> {
        this.$message({
          message: "网络繁忙，请稍后重试！",
          type: 'error',
          center: true,
          duration: 1000
        })
      })
    },
	inputnr1focus(){
		this.inputnr1=''
	}
  } 
}
</script>
<style lang="less" scoped>
.account-table {
  border-top: 1px solid #000000;
  border-left: 1px solid #000000;
  margin: 10px;
  border-spacing: inherit;
  > tr > td {
    border-right: 1px solid #000000;
    border-bottom: 1px solid #000000;
    padding: 5px;
  }
}
#newQianniu .content .qnbox{
	width: 1060px;
    height: 650px;
    position: relative;
}
#newQianniu .content .qnbox .qnicon01{
	position: absolute;
    // top: calc(50% - 37px);
    // bottom: calc(50% - 37px);
    margin-top: -218px;
    // left: calc(50% - 38px);
    // right: calc(50% - 38px);
    margin-left: -285px;
    width: 98px;
    height: 98px;
}
// #newQianniu .content .qnbox .qnicon02
#newQianniu .content .qnbox  .qnicon02-1{
	width: 67px !important;
    height: 21px !important;
	top:216px;
	left:473px;
	cursor: pointer;
	// top: calc(50% - 196px) !important;
	// left: calc(50% - 86px) !important;
    
	}
#newQianniu .content .qnbox  .qnicon04-1{
	width: 176px !important;
    height: 43px !important;
	top:486px;
	left:272px;
	cursor: pointer;
	// top: calc(50% - 196px) !important;
	// left: calc(50% - 86px) !important;
    
	}
#newQianniu .content .qnbox  .qnicon05-1{
	width: 123px !important;
    height: 32px !important;
	top:491px;
	left:286px;
	cursor: pointer;
	// top: calc(50% - 196px) !important;
	// left: calc(50% - 86px) !important;
    
	}
#newQianniu .content .qnbox  .qnicon06-1{
	width: 120px !important;
    height: 92px !important;
	top:389px;
	left:533px;
	cursor: pointer;
	// top: calc(50% - 196px) !important;
	// left: calc(50% - 86px) !important;
    
	}
#newQianniu .content .qnbox  .qnicon09-1{
	width: 59px !important;
    height: 20px !important;
	top:399px;
	left:372px;
	cursor: pointer;
	// top: calc(50% - 196px) !important;
	// left: calc(50% - 86px) !important;
}
#newQianniu .content .qnbox  .qnicon11-1{
	width: 23px !important;
    height: 12px !important;
	top:519px;
	left:260px;
	cursor: pointer;
	// top: calc(50% - 196px) !important;
	// left: calc(50% - 86px) !important;
    
	}
#newQianniu .content .qnbox  .qnicon13-1{
	width: 69px !important;
    height: 15px !important;
	top:461px;
	left:367px;
	cursor: pointer;
	// top: calc(50% - 196px) !important;
	// left: calc(50% - 86px) !important;
    
	}
//测试
#newQianniu .content .con-left{
	height: calc(~'100vh' - 217px) !important;
	width: calc(~'100%' - 210px) !important;
}
#newQianniu .content .con-right{
	height: calc(~'100vh' - 214px);
	width: 200px;
}
//
// #content-second .qnbox .nr1-1{
// 	position:absolute;
// 	width: 71px !important;
//     height: 17px !important;
// 	top:351px;
// 	left:668px;
// 	cursor: pointer;
// 	// top: calc(50% - 196px) !important;
// 	// left: calc(50% - 86px) !important;
    
// 	}
#content-second .qnbox .nr1-1tb{
	position:absolute;
	width: 71px !important;
    height: 15px !important;
	top:352px;
	left:752px;
	cursor: pointer;
	// top: calc(50% - 196px) !important;
	// left: calc(50% - 86px) !important;
}
#content-second .nr1_2input{
	position:absolute;
	width: 71px !important;
    height: 15px !important;
	top:352px;
	left:752px;
	cursor: pointer;
	// top: calc(50% - 196px) !important;
	// left: calc(50% - 86px) !important;
}
#content-second .exclenrbox {
	   width: 1060px;
       height: 650px;

      position: relative;
    
	}

#content-second .qnbox .nr1-3tb{
	position:absolute;
	width: 71px !important;
    height: 15px !important;
	top:329px;
	left:38px;
	cursor: pointer;
	// top: calc(50% - 196px) !important;
	// left: calc(50% - 86px) !important;
}
#content-second .qnbox .nr1_4input{
	position:absolute;
	width: 71px !important;
    height: 16px !important;
	top:370px;
	left:36px;
	cursor: pointer;
	// top: calc(50% - 196px) !important;
	// left: calc(50% - 86px) !important;
}
#content-first .qnbox .qhtb1-1{
	position:absolute;
	width: 18px !important;
    height: 20px !important;
	top:620px;
	left:906px;
	cursor: pointer;

}
#content-first .qnbox .qhtb1-2{
	position:absolute;
	width: 15px !important;
    height: 16px !important;
	top:622px;
	left:908px;
	cursor: pointer;

}
#content-first .qnbox .qhtb1-3{
	position:absolute;
	width: 298px !important;
    height: 62px !important;
	top:424px;
	left:756px;
	cursor: pointer;

}
#content-first .qnbox .qhtb1-4{
	position:absolute;
	width: 296px !important;
    height: 57px !important;
	top:428px;
	left:756px;
	cursor: pointer;

}
#content-first .qnbox .jptb1-1{
	position:absolute;
	width: 14px !important;
    height: 16px !important;
	top:71px;
	left:496px;
	cursor: pointer;

}
#content-first .qnbox .jptb1-2{
	position:absolute;
	width: 19px !important;
    height: 18px !important;
	top:70px;
	left:493px;
	cursor: pointer;

}
#content-first .qnbox .jptb1-3{
	position:absolute;
	width: 249px !important;
    height: 71px !important;
	top:502px;
	left:453px;
	cursor: pointer;

}
#content-first .qnbox .jptb1-4{
	position:absolute;
	width: 84px !important;
    height: 34px !important;
	top:539px;
	left:605px;
	cursor: pointer;

}
#content-first .qnbox .kjtb1-1{
	position:absolute;
	width: 34px !important;
    height: 31px !important;
	top:60px;
	left:337px;
	cursor: pointer;

}
#content-first .qnbox .kjtb1-2{
	position:absolute;
	width: 34px !important;
    height: 31px !important;
	top:59px;
	left:337px;
	cursor: pointer;

}
#content-first .qnbox .kjtb1-3{
	position:absolute;
	width: 249px !important;
    height: 516px !important;
	top:20px;
	left:112px;
	// cursor: pointer;

}
#content-first .qnbox .kjtb1-4{
	position:absolute;
	width: 63px !important;
    height: 48px !important;
	top:438px;
	left:284px;
	cursor: pointer;

}
#content-first .qnbox .kjtb1-5{
	position:absolute;
	width: 34px !important;
    height: 16px !important;
	top:411px;
	left:143px;
	cursor: pointer;

}
#content-first .qnbox .kjtb1-6{
	position:absolute;
	width: 31px !important;
    height: 16px !important;
	top:411px;
	left:143px;
	cursor: pointer;

}
#content-first .qnbox .kjtb1-6-1_box{
	position:absolute;
	width: 674px !important;
    height: 456px !important;
	top:142px;
	left:298px;
	overflow:auto;
	// cursor: pointer;

}
#content-first .qnbox .kjtb1-6-1_box::-webkit-scrollbar{
	display: none !important;

}
#content-first .qnbox .kjtb1-6-1{
	// position:absolute;
	width: 100% !important;
    height: 746px !important;
	// top:133px;
	// left:302px;
	// cursor: pointer;

}
#content-first .qnbox .kjtb1-7{
	position:absolute;
	width: 617px !important;
    height: 466px !important;
	top:133px;
	left:302px;
	// cursor: pointer;

}
#content-first .qnbox .kjtb1-8{
	position:absolute;
	width: 562px !important;
    height:37px !important;
	top:452px;
	left:47px;
	cursor: pointer;

}
#content-first .qnbox .kjtb1-9{
	position:absolute;
	width: 613px !important;
    height:38px !important;
	top:297px;
	left:305px;
	cursor: pointer;

}
#content-first .qnbox .kjtb1-9-1{
	position:absolute;
	width: 674px !important;
    height:472px !important;
	top:127px;
	left:298px;
	overflow: auto;
	// cursor: pointer;

}
#content-first .qnbox .kjtb1-9-1::-webkit-scrollbar{
	display: none;
}
#content-first .qnbox .kjtb1-10{
	// position:absolute;
	width: 100% !important;
    height:682px !important;
	// top:131px;
	// left:303px;
	// cursor: pointer;

}
#content-first .qnbox .kjtb1-11{
	position:absolute;
	width: 606px !important;
    height:39px !important;
	top:466px;
	left:13px;
	cursor: pointer;

}
#content-first .qnbox .kjtb1-12{
	position:absolute;
	width: 17px !important;
    height:17px !important;
	top:389px;
	left:324px;
	cursor: pointer;

}
#content-second .qnbox .dytb1-1{
	position:absolute;
	width: 32px !important;
    height:15px !important;
	top:457px;
	left:157px;
	cursor: pointer;

}
#content-second .qnbox .dytb1-2{
	position:absolute;
	width: 31px !important;
    height:18px !important;
	top:457px;
	left:157px;
	cursor: pointer;

}
#content-second .qnbox .qnbg1-3-1box{
	position:absolute;
	width: 677px !important;
    height:472px !important;
	top:129px;
	left:308px;
	overflow:auto;
	

}
#content-second .qnbox .qnbg1-3-1box::-webkit-scrollbar{display: none;}
#content-second .qnbox .dytb1-3{
	// position:absolute;
	width:100% !important;
    height:700px !important;
	// top:170px;
	// left:315px;


}
#content-second .qnbox .dytb1-4{
	position:absolute;
	width: 588px !important;
    height:39px !important;
	top:575px;
	left:31px;
	cursor: pointer;

}
#content-second .qnbox .dytb1-5{
	position:absolute;
	width: 614px !important;
    height:37px !important;
	top:477px;
	left:316px;
	cursor: pointer;

}
#content-second .qnbox .dytb1-6{
	position:absolute;
	width: 88px !important;
    height:21px !important;
	top:81px;
	left:843px;
	cursor: pointer;}
#content-second .qnbox .dytb1-7{
	position:absolute;
	width: 87px !important;
    height:21px !important;
	top:81px;
	left:843px;
	cursor: pointer;

}
#content-second .qnbox .isShowdy1_7_input{
	position:absolute;
	width: 236px !important;
    // height:25px !important;
	top:218px;
	left:313px;
	cursor: pointer;

}
#content-second .qnbox .isShowdy1_7_input /deep/ .el-input__inner{
height: 32px;

}
#content-second .qnbox .isShowdy1_7_textarea{
	position:absolute;
	width: 450px !important;
    // height:25px !important;
	top:303px;
	left:313px;
	cursor: pointer;

}
#content-second .qnbox .isShowdy1_7_textarea /deep/ .el-textarea__inner{
	height: 114px !important;

}
#content-second .qnbox .dytb1-8{
	position:absolute;
	width: 121px !important;
    height:25px !important;
	top:430px;
	left:317px;
	cursor: pointer;

}
#content-second .qnbox .isShowdy1_7_select{
	position:absolute;
	width: 111px !important;
    height:25px !important;
	top:220px;
	left:589px;
	cursor: pointer;

}
#content-second .qnbox .isShowdy1_7_select /deep/ .el-input__inner{
	background:#F5F7FC;
	height: 28px;
	border-color: #F5F7FC;
}
#content-second .qnbox .isShowdy1_7_select /deep/ .el-select .el-input .el-select__caret{
	color: #000;
	font-size:13px;
	font-weight: 500;
}
#content-second .qnbox .isShowdy1_7_select /deep/ .el-input__icon{
line-height: 38px;
}
#content-second .qnbox .dytb1-9{
	position:absolute;
	width: 84px !important;
    height:26px !important;
	top:430px;
	left:582px;
	cursor: pointer;

}
#content-second .qnbox .dytb2-1{
	position:absolute;
	width: 237px !important;
    height:44px !important;
	top:457px;
	left:525px;
	cursor: pointer;

}
#content-second .qnbox .dytb2-2{
	position:absolute;
	width: 84px !important;
    height:24px !important;
	top:528px;
	left:568px;
	cursor: pointer;

}
</style>


// WEBPACK FOOTER //
// ./src/page/typewriting/typewriting.vue